/* ============================================================
   BED CONFIGURATOR — FRONTEND LOGICA
   Hoort in: extensions/bed-configurator/assets/configurator.js
   Doorvoeren: bestand vervangen, dan `shopify app deploy`
   ============================================================ */

/* =====================================================================
   CONFIG — dit is het enige dat je hoeft aan te passen voor productie
   ===================================================================== */


/* =====================================================================
   TAAL / LANGUAGE
   Standaardtaal is Engels. De taal volgt automatisch de webshop-taal
   (Shopify locale). Ontbreekt een vertaling, dan valt hij terug op Engels.
   Een taal toevoegen = een blok toevoegen aan TRANSLATIONS hieronder.
   ===================================================================== */
const TRANSLATIONS = {
  en: {
    loading:        "Loading configurator…",
    loadError:      "Could not load the configurator data ({msg}). Please check the backend URL.",
    stepOf:         "Step {n} of {total}",
    prev:           "← Previous",
    next:           "Next →",
    dimensions:     "External size: {v}",
    currentConfig:  "Current configuration",
    noBedSelected:  "No bed selected yet",
    total:          "Total",
    required:       "required",
    noAccessories:  "No accessories available for this bed in this step.",
    chooseBedFirst: "Choose a bed type first",
    continueBtn:    "Continue — {price}",
    addToCart:      "Add to cart — {price}",
    addToCartShort: "Add to cart",
    continuePlain:  "Continue",
    addToWishlist:  "Add to wishlist",
    wishlistError:  "Something went wrong while adding to the wishlist.",
    specsTitle:     "Specifications",
    specsShow:      "Specifications",
    specsClose:     "Close",
    moreInfo:       "More information",
    cartBlocked:    "These items can't be added to the cart:",
    cartNotForSale: "not available in the online store",
    startOver:      "Start over",
    startOverAsk:   "Clear all choices and start over?",
    remove:         "Remove",
    fewer:          "One less",
    more:           "One more",
    chooseFirst:    "Please make a choice for: {list}",
    unavailable:    "Currently unavailable",
    bedUnavailable: "This bed can't be ordered at the moment. Please choose a different option.",
    slotTop:        "Top bunk",
    slotBottom:     "Bottom bunk",
    slotOther:      "Sleeping area {n}",
    slotGuest:      "Guest bed",
    slotBedOnly:    "Bed",
    noMattress:     "No mattress",
    noMattressSub:  "I'll arrange a mattress myself",
    sameAsBottom:   "Same as bottom bunk: {v}",
    readMore:       "More info",
    slatsIncluded:  "Included",
    slatsUpgrade:   "Upgrade",
    slatsNoOptions: "No other slatted bases available for this bed.",
    slatsGuide:     "What to choose?",
    guideLoading:   "Loading…",
    guideError:     "Could not load this page.",
    guideOpenPage:  "Open full page",
    infoProductPage:"View product page",
    photoVariant:"View {n}",
    requiresMissing:"Requires {v}",
    subAccessoryTitle:"Additional options for {v} (optional)",
    demoNotice:     "Demo mode. No backend connected, so this shows sample data.",
    cartError:      "Something went wrong while adding to the cart.",
    networkError:   "Network error: {msg}",
    propConfig:     "Configuration",
    propPartOf:     "Part of configuration",
    createQuote:      "Create quote — {price}",
    createQuoteShort: "Create quote",
    quoteModalTitle:  "Create a quote",
    quoteIntro:       "This creates a PDF with the current configuration. No order is placed.",
    quoteEmailLabel:  "Customer's email address",
    quoteEmailPlaceholder: "name@example.com",
    quoteNameLabel:   "Customer's name",
    quoteNamePlaceholder: "Name",
    quoteDealerLabel: "Dealer name",
    quoteDealerPlaceholder: "e.g. Kids Furniture Amsterdam",
    quoteDealerRequired: "Please enter the dealer name.",
    quoteNameRequired: "Please enter the customer's name.",
    quoteDealerEmailLabel: "Dealer's email address",
    quoteDealerEmailPlaceholder: "dealer@example.com",
    quoteInvalidDealerEmail: "Please enter a valid dealer email address.",
    quoteDownloadBtn: "Download PDF",
    quoteEmailBtn:    "Send by email",
    quoteGenerating:  "Creating…",
    quoteCancelBtn:   "Cancel",
    quoteInvalidEmail:"Please enter a valid email address.",
    quoteError:       "Something went wrong while creating the quote.",
    quoteNoItems:     "Please choose a bed first.",
    quoteShareText:   "Quote for {email}",
    quoteMailSubject: "Your Lifetime Kidsrooms quote",
    quoteMailBody:    "Hello,\n\nPlease find the quote attached ({file}).\n\nKind regards,\nLifetime Kidsrooms",
    quotePdfTitle:    "Quote",
    quotePdfDate:     "Date",
    quotePdfDealer:   "Dealer",
    quotePdfCustomer: "Customer",
    quotePdfItem:     "Item",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Qty",
    quotePdfPrice:    "Price",
    quotePdfLineTotal:"Subtotal",
    quotePdfTotal:    "Total",
    quotePdfNoPrices: "Prices are not available in this market.",
    quotePdfFooter:   "This is a non-binding quote, not an order confirmation.",
    quotePdfFooterPrices:      "All prices are recommended retail prices, incl. VAT",
    quotePdfFooterErrors:      "Errors and omissions excepted",
    quotePdfFooterChanges:     "Price and product changes reserved",
    quotePdfFooterColours:     "Colours can differ from reality.",
    quotePdfFooterAvailability:"Due to production constraints, stock availability, or sales considerations, availability can only be confirmed after placing the order.",
    quotePdfContinued:"continued",
  },
  nl: {
    loading:        "Configurator laden…",
    loadError:      "Kon de configuratordata niet laden ({msg}). Controleer de backend-URL.",
    stepOf:         "Stap {n} van {total}",
    prev:           "← Vorige",
    next:           "Volgende →",
    dimensions:     "Buitenmaat: {v}",
    currentConfig:  "Huidige configuratie",
    noBedSelected:  "Nog geen bed geselecteerd",
    total:          "Totaal",
    required:       "verplicht",
    noAccessories:  "Geen accessoires beschikbaar voor dit bed in deze stap.",
    chooseBedFirst: "Kies eerst een bedtype",
    continueBtn:    "Ga verder — {price}",
    addToCart:      "Toevoegen aan winkelmand — {price}",
    addToCartShort: "Toevoegen",
    continuePlain:  "Ga verder",
    addToWishlist:  "Toevoegen aan wishlist",
    wishlistError:  "Er ging iets mis bij het toevoegen aan de wishlist.",
    specsTitle:     "Specificaties",
    specsShow:      "Specificaties",
    specsClose:     "Sluiten",
    moreInfo:       "Meer informatie",
    cartBlocked:    "Deze artikelen kunnen niet in de winkelmand:",
    cartNotForSale: "niet beschikbaar in de webshop",
    startOver:      "Opnieuw beginnen",
    startOverAsk:   "Alle keuzes wissen en opnieuw beginnen?",
    remove:         "Verwijderen",
    fewer:          "Eén minder",
    more:           "Eén meer",
    chooseFirst:    "Maak eerst een keuze bij: {list}",
    unavailable:    "Nu niet leverbaar",
    bedUnavailable: "Dit bed kan op dit moment niet besteld worden. Kies een andere optie.",
    slotTop:        "Bovenbed",
    slotBottom:     "Onderbed",
    slotOther:      "Ligvlak {n}",
    slotGuest:      "Logeerbed",
    slotBedOnly:    "Bed",
    noMattress:     "Geen matras",
    noMattressSub:  "Ik regel zelf een matras",
    sameAsBottom:   "Zelfde als onderbed: {v}",
    readMore:       "Meer info",
    slatsIncluded:  "Inbegrepen",
    slatsUpgrade:   "Upgrade",
    slatsNoOptions: "Geen andere lattenbodems beschikbaar voor dit bed.",
    slatsGuide:     "Wat te kiezen?",
    guideLoading:   "Laden…",
    guideError:     "Kon deze pagina niet laden.",
    guideOpenPage:  "Open volledige pagina",
    infoProductPage:"Bekijk productpagina",
    photoVariant:"Bekijk {n}",
    requiresMissing:"Alleen met {v}",
    subAccessoryTitle:"Aanvullende opties bij {v} (optioneel)",
    demoNotice:     "Demo-modus. Er is geen backend gekoppeld, dus dit toont voorbeelddata.",
    cartError:      "Er ging iets mis bij het toevoegen aan de winkelmand.",
    networkError:   "Netwerkfout: {msg}",
    propConfig:     "Configuratie",
    propPartOf:     "Onderdeel van configuratie",
    createQuote:      "Offerte maken — {price}",
    createQuoteShort: "Offerte maken",
    quoteModalTitle:  "Offerte maken",
    quoteIntro:       "Dit maakt een PDF van de huidige configuratie. Er wordt niets besteld.",
    quoteEmailLabel:  "E-mailadres van de klant",
    quoteEmailPlaceholder: "naam@voorbeeld.nl",
    quoteNameLabel:   "Naam van de klant",
    quoteNamePlaceholder: "Naam",
    quoteDealerLabel: "Naam dealer",
    quoteDealerPlaceholder: "bijv. Kinderkamer Amsterdam",
    quoteDealerRequired: "Vul de naam van de dealer in.",
    quoteNameRequired: "Vul de naam van de klant in.",
    quoteDealerEmailLabel: "E-mailadres van de dealer",
    quoteDealerEmailPlaceholder: "dealer@voorbeeld.nl",
    quoteInvalidDealerEmail: "Vul een geldig e-mailadres van de dealer in.",
    quoteDownloadBtn: "PDF downloaden",
    quoteEmailBtn:    "Per e-mail versturen",
    quoteGenerating:  "Bezig…",
    quoteCancelBtn:   "Annuleren",
    quoteInvalidEmail:"Vul een geldig e-mailadres in.",
    quoteError:       "Er ging iets mis bij het maken van de offerte.",
    quoteNoItems:     "Kies eerst een bed.",
    quoteShareText:   "Offerte voor {email}",
    quoteMailSubject: "Uw offerte van Lifetime Kidsrooms",
    quoteMailBody:    "Hallo,\n\nHierbij de offerte als bijlage ({file}).\n\nMet vriendelijke groet,\nLifetime Kidsrooms",
    quotePdfTitle:    "Offerte",
    quotePdfDate:     "Datum",
    quotePdfDealer:   "Dealer",
    quotePdfCustomer: "Klant",
    quotePdfItem:     "Artikel",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Aantal",
    quotePdfPrice:    "Prijs",
    quotePdfLineTotal:"Subtotaal",
    quotePdfTotal:    "Totaal",
    quotePdfNoPrices: "Prijzen zijn niet beschikbaar in deze markt.",
    quotePdfFooter:   "Dit is een vrijblijvende offerte, geen orderbevestiging.",
    quotePdfFooterPrices:      "Alle prijzen zijn adviesverkoopprijzen, inclusief btw",
    quotePdfFooterErrors:      "Zet- en drukfouten voorbehouden",
    quotePdfFooterChanges:     "Prijs- en productwijzigingen voorbehouden",
    quotePdfFooterColours:     "Kleuren kunnen afwijken van de werkelijkheid.",
    quotePdfFooterAvailability:"Vanwege productiebeperkingen, voorraad of verkoopoverwegingen kan beschikbaarheid pas na het plaatsen van de bestelling worden bevestigd.",
    quotePdfContinued:"vervolg",
  },
  da: {
    loading:        "Indlæser konfigurator…",
    loadError:      "Konfiguratorens data kunne ikke indlæses ({msg}). Kontrollér backend-URL'en.",
    stepOf:         "Trin {n} af {total}",
    prev:           "← Tilbage",
    next:           "Videre →",
    dimensions:     "Udvendige mål: {v}",
    currentConfig:  "Din konfiguration",
    noBedSelected:  "Ingen seng valgt endnu",
    total:          "I alt",
    required:       "påkrævet",
    noAccessories:  "Der er intet tilbehør til denne seng i dette trin.",
    chooseBedFirst: "Vælg først en sengetype",
    continueBtn:    "Videre — {price}",
    addToCart:      "Læg i kurv — {price}",
    addToCartShort: "Læg i kurv",
    continuePlain:  "Videre",
    addToWishlist:  "Føj til ønskeliste",
    wishlistError:  "Noget gik galt, da varen skulle føjes til ønskelisten.",
    specsTitle:     "Specifikationer",
    specsShow:      "Specifikationer",
    specsClose:     "Luk",
    moreInfo:       "Mere information",
    cartBlocked:    "Disse varer kan ikke lægges i kurven:",
    cartNotForSale: "ikke tilgængelig i webshoppen",
    startOver:      "Start forfra",
    startOverAsk:   "Vil du rydde alle valg og starte forfra?",
    remove:         "Fjern",
    fewer:          "Én mindre",
    more:           "Én mere",
    chooseFirst:    "Vælg venligst noget under: {list}",
    unavailable:    "Ikke tilgængelig lige nu",
    bedUnavailable: "Denne seng kan ikke bestilles lige nu. Vælg en anden mulighed.",
    slotTop:        "Øverste køje",
    slotBottom:     "Nederste køje",
    slotOther:      "Liggeflade {n}",
    slotGuest:      "Gæstebed",
    slotBedOnly:    "Seng",
    noMattress:     "Ingen madras",
    noMattressSub:  "Jeg ordner selv en madras",
    sameAsBottom:   "Samme som nederste køje: {v}",
    readMore:       "Mere info",
    slatsIncluded:  "Inkluderet",
    slatsUpgrade:   "Opgradering",
    slatsNoOptions: "Der er ingen andre lamelbunde til denne seng.",
    slatsGuide:     "Hvad skal jeg vælge?",
    guideLoading:   "Indlæser…",
    guideError:     "Siden kunne ikke indlæses.",
    guideOpenPage:  "Åbn hele siden",
    infoProductPage:"Se produktsiden",
    photoVariant:"Se {n}",
    requiresMissing:"Kræver {v}",
    subAccessoryTitle:"Yderligere valgmuligheder til {v} (valgfrit)",
    demoNotice:     "Demotilstand. Ingen backend tilsluttet, så dette er eksempeldata.",
    cartError:      "Noget gik galt, da varen skulle lægges i kurven.",
    networkError:   "Netværksfejl: {msg}",
    propConfig:     "Konfiguration",
    propPartOf:     "Del af konfiguration",
    createQuote:      "Opret tilbud — {price}",
    createQuoteShort: "Opret tilbud",
    quoteModalTitle:  "Opret tilbud",
    quoteIntro:       "Dette laver en PDF med den aktuelle konfiguration. Der bestilles ikke noget.",
    quoteEmailLabel:  "Kundens e-mailadresse",
    quoteEmailPlaceholder: "navn@eksempel.dk",
    quoteNameLabel:   "Kundens navn",
    quoteNamePlaceholder: "Navn",
    quoteDealerLabel: "Forhandlernavn",
    quoteDealerPlaceholder: "f.eks. Børneværelse København",
    quoteDealerRequired: "Indtast venligst forhandlerens navn.",
    quoteNameRequired: "Indtast venligst kundens navn.",
    quoteDealerEmailLabel: "Forhandlerens e-mailadresse",
    quoteDealerEmailPlaceholder: "forhandler@eksempel.dk",
    quoteInvalidDealerEmail: "Indtast venligst en gyldig e-mailadresse for forhandleren.",
    quoteDownloadBtn: "Download PDF",
    quoteEmailBtn:    "Send via e-mail",
    quoteGenerating:  "Behandler…",
    quoteCancelBtn:   "Annuller",
    quoteInvalidEmail:"Indtast venligst en gyldig e-mailadresse.",
    quoteError:       "Noget gik galt under oprettelsen af tilbuddet.",
    quoteNoItems:     "Vælg først en seng.",
    quoteShareText:   "Tilbud til {email}",
    quoteMailSubject: "Dit tilbud fra Lifetime Kidsrooms",
    quoteMailBody:    "Hej,\n\nSe venligst det vedhæftede tilbud ({file}).\n\nMed venlig hilsen,\nLifetime Kidsrooms",
    quotePdfTitle:    "Tilbud",
    quotePdfDate:     "Dato",
    quotePdfDealer:   "Forhandler",
    quotePdfCustomer: "Kunde",
    quotePdfItem:     "Vare",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Antal",
    quotePdfPrice:    "Pris",
    quotePdfLineTotal:"Subtotal",
    quotePdfTotal:    "I alt",
    quotePdfNoPrices: "Priser er ikke tilgængelige i dette marked.",
    quotePdfFooter:   "Dette er et uforpligtende tilbud, ikke en ordrebekræftelse.",
    quotePdfFooterPrices:      "Alle priser er vejledende udsalgspriser, inkl. moms",
    quotePdfFooterErrors:      "Der tages forbehold for trykfejl",
    quotePdfFooterChanges:     "Der tages forbehold for pris- og produktændringer",
    quotePdfFooterColours:     "Farver kan afvige fra virkeligheden.",
    quotePdfFooterAvailability:"På grund af produktionsbegrænsninger, lagerbeholdning eller salgsmæssige hensyn kan tilgængelighed først bekræftes efter afgivelse af ordren.",
    quotePdfContinued:"fortsat",
  },
  de: {
    loading:        "Konfigurator wird geladen…",
    loadError:      "Die Konfiguratordaten konnten nicht geladen werden ({msg}). Bitte die Backend-URL prüfen.",
    stepOf:         "Schritt {n} von {total}",
    prev:           "← Zurück",
    next:           "Weiter →",
    dimensions:     "Außenmaße: {v}",
    currentConfig:  "Ihre Konfiguration",
    noBedSelected:  "Noch kein Bett ausgewählt",
    total:          "Gesamt",
    required:       "erforderlich",
    noAccessories:  "Für dieses Bett gibt es in diesem Schritt kein Zubehör.",
    chooseBedFirst: "Wählen Sie zuerst einen Betttyp",
    continueBtn:    "Weiter — {price}",
    addToCart:      "In den Warenkorb — {price}",
    addToCartShort: "In den Warenkorb",
    continuePlain:  "Weiter",
    addToWishlist:  "Auf die Wunschliste",
    wishlistError:  "Beim Hinzufügen zur Wunschliste ist etwas schiefgelaufen.",
    specsTitle:     "Spezifikationen",
    specsShow:      "Spezifikationen",
    specsClose:     "Schließen",
    moreInfo:       "Weitere Informationen",
    cartBlocked:    "Diese Artikel können nicht in den Warenkorb gelegt werden:",
    cartNotForSale: "im Onlineshop nicht verfügbar",
    startOver:      "Neu beginnen",
    startOverAsk:   "Alle Auswahlen löschen und neu beginnen?",
    remove:         "Entfernen",
    fewer:          "Eins weniger",
    more:           "Eins mehr",
    chooseFirst:    "Bitte treffen Sie eine Auswahl bei: {list}",
    unavailable:    "Zurzeit nicht verfügbar",
    bedUnavailable: "Dieses Bett kann derzeit nicht bestellt werden. Bitte wählen Sie eine andere Option.",
    slotTop:        "Oberes Bett",
    slotBottom:     "Unteres Bett",
    slotOther:      "Liegefläche {n}",
    slotGuest:      "Gästebett",
    slotBedOnly:    "Bett",
    noMattress:     "Keine Matratze",
    noMattressSub:  "Ich besorge selbst eine Matratze",
    sameAsBottom:   "Wie das untere Bett: {v}",
    readMore:       "Mehr Infos",
    slatsIncluded:  "Inklusive",
    slatsUpgrade:   "Aufpreis",
    slatsNoOptions: "Für dieses Bett gibt es keine anderen Lattenroste.",
    slatsGuide:     "Was soll ich wählen?",
    guideLoading:   "Wird geladen…",
    guideError:     "Diese Seite konnte nicht geladen werden.",
    guideOpenPage:  "Ganze Seite öffnen",
    infoProductPage:"Zur Produktseite",
    photoVariant:"Ansicht {n}",
    requiresMissing:"Nur mit {v}",
    subAccessoryTitle:"Zusätzliche Optionen für {v} (optional)",
    demoNotice:     "Demomodus. Kein Backend verbunden, daher werden Beispieldaten gezeigt.",
    cartError:      "Beim Hinzufügen zum Warenkorb ist etwas schiefgelaufen.",
    networkError:   "Netzwerkfehler: {msg}",
    propConfig:     "Konfiguration",
    propPartOf:     "Teil der Konfiguration",
    createQuote:      "Angebot erstellen — {price}",
    createQuoteShort: "Angebot erstellen",
    quoteModalTitle:  "Angebot erstellen",
    quoteIntro:       "Damit wird ein PDF der aktuellen Konfiguration erstellt. Es wird nichts bestellt.",
    quoteEmailLabel:  "E-Mail-Adresse des Kunden",
    quoteEmailPlaceholder: "name@beispiel.de",
    quoteNameLabel:   "Name des Kunden",
    quoteNamePlaceholder: "Name",
    quoteDealerLabel: "Händlername",
    quoteDealerPlaceholder: "z. B. Kinderzimmer Berlin",
    quoteDealerRequired: "Bitte geben Sie den Händlernamen ein.",
    quoteNameRequired: "Bitte geben Sie den Namen des Kunden ein.",
    quoteDealerEmailLabel: "E-Mail-Adresse des Händlers",
    quoteDealerEmailPlaceholder: "haendler@beispiel.de",
    quoteInvalidDealerEmail: "Bitte geben Sie eine gültige E-Mail-Adresse des Händlers ein.",
    quoteDownloadBtn: "PDF herunterladen",
    quoteEmailBtn:    "Per E-Mail senden",
    quoteGenerating:  "Wird erstellt…",
    quoteCancelBtn:   "Abbrechen",
    quoteInvalidEmail:"Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    quoteError:       "Beim Erstellen des Angebots ist etwas schiefgelaufen.",
    quoteNoItems:     "Bitte wählen Sie zuerst ein Bett.",
    quoteShareText:   "Angebot für {email}",
    quoteMailSubject: "Ihr Angebot von Lifetime Kidsrooms",
    quoteMailBody:    "Hallo,\n\nanbei das Angebot ({file}).\n\nMit freundlichen Grüßen,\nLifetime Kidsrooms",
    quotePdfTitle:    "Angebot",
    quotePdfDate:     "Datum",
    quotePdfDealer:   "Händler",
    quotePdfCustomer: "Kunde",
    quotePdfItem:     "Artikel",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Menge",
    quotePdfPrice:    "Preis",
    quotePdfLineTotal:"Zwischensumme",
    quotePdfTotal:    "Gesamt",
    quotePdfNoPrices: "Preise sind in diesem Markt nicht verfügbar.",
    quotePdfFooter:   "Dies ist ein unverbindliches Angebot, keine Auftragsbestätigung.",
    quotePdfFooterPrices:      "Alle Preise sind unverbindliche Preisempfehlungen, inkl. MwSt.",
    quotePdfFooterErrors:      "Druckfehler vorbehalten",
    quotePdfFooterChanges:     "Preis- und Produktänderungen vorbehalten",
    quotePdfFooterColours:     "Farben können von der Realität abweichen.",
    quotePdfFooterAvailability:"Aufgrund von Produktionsbeschränkungen, Lagerbeständen oder verkaufsbezogenen Erwägungen kann die Verfügbarkeit erst nach Auftragserteilung bestätigt werden.",
    quotePdfContinued:"Fortsetzung",
  },
  fr: {
    loading:        "Chargement du configurateur…",
    loadError:      "Impossible de charger les données du configurateur ({msg}). Vérifiez l'URL du backend.",
    stepOf:         "Étape {n} sur {total}",
    prev:           "← Précédent",
    next:           "Suivant →",
    dimensions:     "Dimensions extérieures : {v}",
    currentConfig:  "Votre configuration",
    noBedSelected:  "Aucun lit sélectionné",
    total:          "Total",
    required:       "obligatoire",
    noAccessories:  "Aucun accessoire disponible pour ce lit à cette étape.",
    chooseBedFirst: "Choisissez d'abord un type de lit",
    continueBtn:    "Continuer — {price}",
    addToCart:      "Ajouter au panier — {price}",
    addToCartShort: "Ajouter au panier",
    continuePlain:  "Continuer",
    addToWishlist:  "Ajouter à la liste d'envies",
    wishlistError:  "Une erreur s'est produite lors de l'ajout à la liste d'envies.",
    specsTitle:     "Caractéristiques",
    specsShow:      "Caractéristiques",
    specsClose:     "Fermer",
    moreInfo:       "Plus d'informations",
    cartBlocked:    "Ces articles ne peuvent pas être ajoutés au panier :",
    cartNotForSale: "non disponible dans la boutique en ligne",
    startOver:      "Recommencer",
    startOverAsk:   "Effacer tous les choix et recommencer ?",
    remove:         "Supprimer",
    fewer:          "Un de moins",
    more:           "Un de plus",
    chooseFirst:    "Veuillez faire un choix pour : {list}",
    unavailable:    "Momentanément indisponible",
    bedUnavailable: "Ce lit ne peut pas être commandé pour le moment. Veuillez choisir une autre option.",
    slotTop:        "Couchage supérieur",
    slotBottom:     "Couchage inférieur",
    slotOther:      "Couchage {n}",
    slotGuest:      "Lit d'appoint",
    slotBedOnly:    "Lit",
    noMattress:     "Pas de matelas",
    noMattressSub:  "Je m'occupe moi-même du matelas",
    sameAsBottom:   "Identique au couchage inférieur : {v}",
    readMore:       "Plus d'infos",
    slatsIncluded:  "Inclus",
    slatsUpgrade:   "Supplément",
    slatsNoOptions: "Aucun autre sommier n'est disponible pour ce lit.",
    slatsGuide:     "Que choisir ?",
    guideLoading:   "Chargement…",
    guideError:     "Impossible de charger cette page.",
    guideOpenPage:  "Ouvrir la page complète",
    infoProductPage:"Voir la fiche produit",
    photoVariant:"Voir {n}",
    requiresMissing:"Nécessite {v}",
    subAccessoryTitle:"Options supplémentaires pour {v} (facultatif)",
    demoNotice:     "Mode démo. Aucun backend connecté : les données sont fictives.",
    cartError:      "Une erreur s'est produite lors de l'ajout au panier.",
    networkError:   "Erreur réseau : {msg}",
    propConfig:     "Configuration",
    propPartOf:     "Fait partie de la configuration",
    createQuote:      "Créer un devis — {price}",
    createQuoteShort: "Créer un devis",
    quoteModalTitle:  "Créer un devis",
    quoteIntro:       "Ceci crée un PDF de la configuration actuelle. Aucune commande n'est passée.",
    quoteEmailLabel:  "Adresse e-mail du client",
    quoteEmailPlaceholder: "nom@exemple.fr",
    quoteNameLabel:   "Nom du client",
    quoteNamePlaceholder: "Nom",
    quoteDealerLabel: "Nom du revendeur",
    quoteDealerPlaceholder: "p. ex. Chambre d'enfant Paris",
    quoteDealerRequired: "Veuillez saisir le nom du revendeur.",
    quoteNameRequired: "Veuillez saisir le nom du client.",
    quoteDealerEmailLabel: "Adresse e-mail du revendeur",
    quoteDealerEmailPlaceholder: "revendeur@exemple.fr",
    quoteInvalidDealerEmail: "Veuillez saisir une adresse e-mail valide pour le revendeur.",
    quoteDownloadBtn: "Télécharger le PDF",
    quoteEmailBtn:    "Envoyer par e-mail",
    quoteGenerating:  "Création…",
    quoteCancelBtn:   "Annuler",
    quoteInvalidEmail:"Veuillez saisir une adresse e-mail valide.",
    quoteError:       "Une erreur s'est produite lors de la création du devis.",
    quoteNoItems:     "Veuillez d'abord choisir un lit.",
    quoteShareText:   "Devis pour {email}",
    quoteMailSubject: "Votre devis Lifetime Kidsrooms",
    quoteMailBody:    "Bonjour,\n\nVeuillez trouver le devis en pièce jointe ({file}).\n\nCordialement,\nLifetime Kidsrooms",
    quotePdfTitle:    "Devis",
    quotePdfDate:     "Date",
    quotePdfDealer:   "Revendeur",
    quotePdfCustomer: "Client",
    quotePdfItem:     "Article",
    quotePdfSku:      "SKU",
    quotePdfQty:      "Qté",
    quotePdfPrice:    "Prix",
    quotePdfLineTotal:"Sous-total",
    quotePdfTotal:    "Total",
    quotePdfNoPrices: "Les prix ne sont pas disponibles sur ce marché.",
    quotePdfFooter:   "Ceci est un devis sans engagement, pas une confirmation de commande.",
    quotePdfFooterPrices:      "Tous les prix sont des prix de vente conseillés, TVA incluse",
    quotePdfFooterErrors:      "Sous réserve d'erreurs typographiques",
    quotePdfFooterChanges:     "Sous réserve de modifications de prix et de produits",
    quotePdfFooterColours:     "Les couleurs peuvent différer de la réalité.",
    quotePdfFooterAvailability:"En raison de contraintes de production, de la disponibilité des stocks ou de considérations commerciales, la disponibilité ne peut être confirmée qu'après la passation de la commande.",
    quotePdfContinued:"suite",
  },
};

function detectLocale(){
  const fromSetting = window.BED_CONFIGURATOR_SETTINGS && window.BED_CONFIGURATOR_SETTINGS.locale;
  const raw = fromSetting
    || (window.Shopify && window.Shopify.locale)
    || document.documentElement.getAttribute("lang")
    || "en";
  return String(raw).toLowerCase().split("-")[0];
}
const LOCALE = detectLocale();

// t("stepOf", {n:1, total:4})  ->  "Step 1 of 4"
function t(key, vars){
  const dict = TRANSLATIONS[LOCALE] || TRANSLATIONS.en;
  let str = (dict && dict[key]) || TRANSLATIONS.en[key] || key;
  if (vars) for (const k in vars) str = str.replace("{"+k+"}", vars[k]);
  return str;
}

// Tekst uit de Google Sheet kan per taal: kolom "title" is Engels (default),
// kolom "title_nl" wordt gebruikt als de winkel in het Nederlands staat.
function sheetText(row, field){
  if (!row) return "";
  return row[field + "_" + LOCALE] || row[field] || "";
}

/* =====================================================================
   DEMO-DATA — exact de vorm die de backend teruggeeft.
   (steps / beds / accessories / compatibility / filters)
   Bij een gekoppelde backend wordt dit volledig genegeerd.
   ===================================================================== */
const IMG = {
  bedOriginal:"https://lifetimekidsrooms.com/cdn/shop/files/ORIGINAL_BUNKBED_4630-10_375x375_crop_center.png?v=1778497256",
  bedElements:"https://lifetimekidsrooms.com/cdn/shop/files/ELEMENTS_SINGLE_04.jpg?v=1773832718",
  bedBreeze:"https://lifetimekidsrooms.com/cdn/shop/files/four-poster-canopy-bed-breeze-8488242.webp?v=1772024014",
  bedCabin:"https://lifetimekidsrooms.com/cdn/shop/files/cabin-bed-120x200-cm-5265539.jpg?v=1773234216",
  matClassic:"https://lifetimekidsrooms.com/cdn/shop/files/soft-foam-mattress-classic-9983007_375x375_crop_center.png?v=1763027980",
  matAdvanced:"https://lifetimekidsrooms.com/cdn/shop/files/high-resistance-foam-mattress-advanced-2982258_375x375_crop_center.webp?v=1763027966",
  matLight:"https://lifetimekidsrooms.com/cdn/shop/files/basic-mattress-light-4201448_375x375_crop_center.png?v=1763070023",
  matPocket:"https://lifetimekidsrooms.com/cdn/shop/files/pocket-spring-mattress-5787236_375x375_crop_center.png?v=1763070034",
  slatDeluxe:"https://lifetimekidsrooms.com/cdn/shop/files/deluxe-slatted-base-8182506_375x375_crop_center.webp?v=1761033112",
  slatStandard:"https://lifetimekidsrooms.com/cdn/shop/files/standard-slatted-base-4953985_375x375_crop_center.webp?v=1761032878",
};

const DEMO_DATA = {
  steps: [
    {step_no:"1", title:"Choose your bed type", subtitle:"Select options to build the bed.", type:"single", active:"yes"},
    {step_no:"2", title:"Mattress & bedding", subtitle:"Mattress is required, the rest optional.", type:"multiple", active:"yes"},
    {step_no:"3", title:"Wooden accessories", subtitle:"Optional storage solutions.", type:"multiple", active:"yes"},
    {step_no:"4", title:"Extra safety", subtitle:"Optional safety accessories.", type:"multiple", active:"yes"},
  ],
  filters: [
    {order:"1", filter_key:"filter_style", label:"Design style", active:"yes"},
    {order:"2", filter_key:"filter_bedtype", label:"Bed type", active:"yes"},
    {order:"3", filter_key:"filter_colour", label:"Colour palette", active:"yes"},
    {order:"4", filter_key:"filter_width", label:"Bed width", active:"yes"},
    {order:"5", filter_key:"filter_top", label:"Top design", active:"yes"},
    {order:"6", filter_key:"filter_ladder", label:"Ladder", active:"yes"},
    {order:"7", filter_key:"filter_slats", label:"Slatted base", active:"yes"},
  ],
  beds: [
    {sku:"4630-10", variant_id:"demo-b1", filter_style:"Original", filter_bedtype:"Bunkbed 177 cm", filter_colour:"White", filter_width:"90", filter_top:"None", filter_ladder:"Ladder", filter_slats:"16 curved slats",
      shopify:{title:"Stapelbed Original", image:IMG.bedOriginal, price:"429.00", currency:"EUR", dimensions:"H177 × L207 × B102 cm", defaultVariantId:"demo-b1"}},
    {sku:"ELEM-04", variant_id:"demo-b2", filter_style:"Elements", filter_bedtype:"Single", filter_colour:"Whitewash", filter_width:"90", filter_top:"None", filter_ladder:"None", filter_slats:"23 curved slats",
      shopify:{title:"Elements Single", image:IMG.bedElements, price:"389.00", currency:"EUR", dimensions:"H67 × L207 × B98 cm", defaultVariantId:"demo-b2"}},
    {sku:"210-10", variant_id:"demo-b3", filter_style:"Breeze", filter_bedtype:"Single", filter_colour:"White", filter_width:"90", filter_top:"4-Poster", filter_ladder:"None", filter_slats:"28 slats slatbase",
      shopify:{title:"Breeze Four-Poster", image:IMG.bedBreeze, price:"189.00", currency:"EUR", dimensions:"H205 × L207 × B98 cm", defaultVariantId:"demo-b3"}},
    {sku:"CABIN-120", variant_id:"demo-b4", filter_style:"Original", filter_bedtype:"Mid Sleeper", filter_colour:"White", filter_width:"120", filter_top:"House", filter_ladder:"Ladder", filter_slats:"23 curved slats",
      shopify:{title:"Cabin Bed", image:IMG.bedCabin, price:"549.00", currency:"EUR", dimensions:"H113 × L207 × B128 cm", defaultVariantId:"demo-b4"}},
  ],
  accessories: [
    {step_no:"2", category:"Mattress", sku:"MAT-CL", variant_id:"demo-a1", selection:"single", required:"yes",
      shopify:{title:"Soft foam mattress CLASSIC", image:IMG.matClassic, price:"89.00", currency:"EUR", defaultVariantId:"demo-a1"}},
    {step_no:"2", category:"Mattress", sku:"MAT-ADV", variant_id:"demo-a2", selection:"single", required:"yes",
      shopify:{title:"Foam mattress ADVANCED", image:IMG.matAdvanced, price:"119.00", currency:"EUR", defaultVariantId:"demo-a2"}},
    {step_no:"2", category:"Bedding", sku:"MAT-LT", variant_id:"demo-a3", selection:"single", required:"no",
      shopify:{title:"Mattress LIGHT", image:IMG.matLight, price:"59.00", currency:"EUR", defaultVariantId:"demo-a3"}},
    {step_no:"2", category:"Bedding", sku:"MAT-PK", variant_id:"demo-a4", selection:"single", required:"no",
      shopify:{title:"Pocket spring mattress", image:IMG.matPocket, price:"139.00", currency:"EUR", defaultVariantId:"demo-a4"}},
    {step_no:"3", category:"Wooden accessories", sku:"SLAT-DX", variant_id:"demo-a5", selection:"single", required:"no",
      shopify:{title:"Bookshelf", image:IMG.slatDeluxe, price:"99.00", currency:"EUR", defaultVariantId:"demo-a5"}},
    {step_no:"3", category:"Wooden accessories", sku:"SLAT-ST", variant_id:"demo-a6", selection:"single", required:"no",
      shopify:{title:"Mini nightstand", image:IMG.slatStandard, price:"59.00", currency:"EUR", defaultVariantId:"demo-a6"}},
    {step_no:"4", category:"Extra safety", sku:"SAF-DX", variant_id:"demo-a7", selection:"multiple", required:"no",
      shopify:{title:"Reinforced slatted base 200kg", image:IMG.slatDeluxe, price:"99.00", currency:"EUR", defaultVariantId:"demo-a7"}},
  ],
  compatibility: [
    {sku:"MAT-CL",  compatible_with_sku:"4630-10, ELEM-04, 210-10", note:""},
    {sku:"MAT-ADV", compatible_with_sku:"ALL", note:""},
    {sku:"MAT-LT",  compatible_with_sku:"4630-10, ELEM-04, 210-10, CABIN-120", note:""},
    {sku:"MAT-PK",  compatible_with_sku:"CABIN-120", note:""},
    {sku:"SLAT-DX", compatible_with_sku:"ALL", note:""},
    {sku:"SLAT-ST", compatible_with_sku:"ALL", note:""},
    {sku:"SAF-DX",  compatible_with_sku:"4630-10, CABIN-120", note:""},
  ],
};

/* =====================================================================
   STATE
   ===================================================================== */
let DATA = null;
let currentStep = 1;
let filters = {};
let selectedBed = null;
let actieveFoto = 0;   // 0 = hoofdbeeld, 1-6 = configurator_{SKU}-{n}.webp
let bevestigdeFotos = {};   // sku -> Set van nummers die echt bestaan (na succesvol laden)      // bed object
let selectedAcc = {};        // keuze-sleutel -> acc object
let accQty = {};             // keuze-sleutel -> aantal (minimaal 1)

/* Bewuste "geen"-keuze (5 okt 2026), voor stappen met het veld "Moet kiezen"
   (bv. Matrassen): de klant moet bij elk ligvlak kiezen, en mag daarbij ook
   bewust "Geen matras" kiezen. Sleutel = "stap|categorie|ligvlak", zie geenKey().
   Een bewuste "geen" heeft geen artikel, dus komt hij niet in de winkelmand. */
let geenKeuze = {};
/* Scherm binnen de huidige stap. Bij een bed met twee ligvlakken krijgt elk
   ligvlak een eigen scherm (eerst het onderbed, dan het bovenbed): 0 = eerste. */
let currentSub = 0;

/* Sub-accessoires (12 sep 2026), bv. een matras die alleen kiesbaar wordt
   zodra een specifiek ANDER accessoire (bv. een logeerbed) al gekozen is.
   Bewust een eigen, simpel object -- los van selectedAcc/accQty -- want een
   sub-accessoire heeft geen ligvlak-sleutel (accKey/skuOfKey/slotOfKey zijn
   hier niet van toepassing) en altijd precies 1 stuk. Sleutel = SKU in
   hoofdletters. Zie subAccessoryOf() verderop voor hoe de koppeling werkt. */
let selectedSubAcc = {};     // sku (hoofdletters) -> acc object
/* Aantal per sub-accessoire (12 sep 2026 uitgebreid met max_qty, 10 sep 2026).
   Los van accQty, want de sleutel is hier altijd de kale SKU (geen ligvlak). */
let subAccQty = {};          // sku (hoofdletters) -> aantal (minimaal 1)

/* Een keuze-sleutel is normaal gewoon de SKU. Heeft het bed twee ligvlakken,
   dan krijgt elk ligvlak een eigen sleutel: "70921@0" is het bovenbed,
   "70921@1" het onderbed. Zo kan hetzelfde matras twee keer gekozen worden. */
function accKey(sku, slot){ return (slot === null || slot === undefined) ? String(sku) : `${sku}@${slot}`; }
function skuOfKey(key){ return String(key).split("@")[0]; }
function slotOfKey(key){
  const d = String(key).split("@");
  return d.length > 1 ? Number(d[1]) : null;
}
const MAX_QTY = 10;

// Hoeveel stuks mag de klant hiervan kiezen? Kolom max_qty in het tabblad
// Accessories. Leeg, 1, of onleesbaar = geen aantalkeuze.
function maxQtyFor(acc){
  const n = parseInt(String((acc && acc.max_qty) || "").trim(), 10);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(n, MAX_QTY);
}
// max_qty bepaalt hoeveel KAARTJES er in het overzicht staan. In de
// rechterkolom mag de klant altijd bijstellen, tot het plafond van MAX_QTY.
function qtyOf(key){
  return Math.min(MAX_QTY, Math.max(1, accQty[key] || 1));
}

// Alles wat de klant gekozen heeft, met het aantal erbij.
function chosenItems(){
  const uit = [];
  if (selectedBed) uit.push({ key: null, item: selectedBed, qty: 1, isBed: true });
  for (const [key, a] of Object.entries(selectedAcc)) {
    uit.push({ key, item: a, qty: qtyOf(key), isBed: false });
  }
  // Sub-accessoires tellen mee als gewoon accessoire (winkelmand, offerte,
  // totaal), met hun eigen aantal (max_qty) -- geen eigen ligvlak-sleutel.
  for (const [key, a] of Object.entries(selectedSubAcc)) {
    uit.push({ key, item: a, qty: qtyOfSubAcc(key), isBed: false });
  }
  return uit;
}

/* =====================================================================
   DATA LOADING
   ===================================================================== */
// Staat de data al in de pagina (Liquid-sectie configurator-data)? Dan die
// gebruiken. Anders de backend, en anders de demo-data. Zo kan de winkel
// overstappen zonder dat er een moment is waarop niets werkt.
// Eén regel in de console: waar komt de data vandaan? Scheelt uitzoekwerk.
function meldBron(bron){
  const n = (DATA && DATA.beds) ? DATA.beds.length : 0;
  const a = (DATA && DATA.accessories) ? DATA.accessories.length : 0;
  console.info(`%cBed configurator%c bron: ${bron} — ${n} bedden, ${a} accessoires, taal ${LOCALE}`,
    "background:#59422F;color:#E7C696;padding:2px 6px;border-radius:4px;font-weight:700",
    "color:inherit");

  // Eén keer per bezoek: iemand heeft de tool geopend en data is geladen.
  // Niet meegeteld: demo-data, want dat is een proefsessie, geen bezoeker.
  const isDemo = bron.indexOf("demo") !== -1;
  if (!isDemo && !gebruikGemeld) {
    gebruikGemeld = true;
    meetGebeurtenis("bed_configurator_view", { source: bron.split(" ")[0], channel: meetKanaal() });
  }
}

function dataUitPagina(){
  const el = document.getElementById('bed-configurator-data');
  if (!el) return null;
  try {
    const d = JSON.parse(el.textContent);
    if (!d || !Array.isArray(d.beds) || !d.beds.length) return null;
    return d;
  } catch (e) {
    console.error("Configuratordata in de pagina is onleesbaar:", e);
    return null;
  }
}

async function loadData(){
  document.getElementById('app').innerHTML = `<div class="loading">${t("loading")}</div>`;

  // De data-sectie op de pagina is de enige bron. Ontbreekt die, dan draait
  // de configurator op demo-data -- geen externe backend meer als vangnet.
  const uitPagina = dataUitPagina();
  if (uitPagina) {
    DATA = normalise(uitPagina, "liquid");
    meldBron("Shopify (Liquid, data in de pagina)");
    initFilters(); render();
    return;
  }

  DATA = normalise(DEMO_DATA, "demo");
  meldBron("demo-data (geen data-sectie gevonden op deze pagina)");
  const banner = document.getElementById('demoBanner');
  banner.innerHTML = '<span>' + t("demoNotice") + '</span>';
  banner.style.display = 'flex';
  initFilters(); render();
}

/* Liquid levert prijzen in centen (129900), de backend in eenheden (1299.00).
   We rekenen alles om naar eenheden, zodat de rest van de code niets merkt. */
function normaliseerPrijzen(d, bron){
  if (bron !== "liquid") return;
  [...(d.beds||[]), ...(d.accessories||[])].forEach(x => {
    if (x.shopify && x.shopify.price != null && x.shopify.price !== "") {
      x.shopify.price = Number(x.shopify.price) / 100;
    }
  });
}

/* Zorgt dat compatibiliteit snel opzoekbaar is en actieve items gefilterd zijn */
function normalise(d, bron){
  normaliseerPrijzen(d, bron);
  // De backend levert compatibility al als { "SKU": ["SKU","SKU"] | "ALL" }.
  // Voor de demo-data (array-vorm) zetten we het hier alsnog om.
  let compatMap = {};
  if (Array.isArray(d.compatibility)) {
    (d.compatibility||[]).forEach(row=>{
      const sku = (row.sku||"").trim().toUpperCase();
      if(!sku) return;
      const raw = (row.compatible_with_sku||"").trim();
      compatMap[sku] = raw.toUpperCase()==="ALL"
        ? "ALL"
        : raw.split(",").map(s=>s.trim().toUpperCase()).filter(Boolean);
    });
  } else if (d.compatibility) {
    compatMap = d.compatibility;
  } else {
    // Liquid levert geen kant-en-klare lijst maar de rauwe regel per accessoire.
    compatMap = bouwCompatMap(d.accessories || [], d.beds || []);
  }
  CURRENCY = detectCurrency(d);
  const isActive = x => (x.active===undefined) || String(x.active).toLowerCase()==="yes";
  return {
    steps: (d.steps||[]).filter(isActive).sort((a,b)=>(+a.step_no)-(+b.step_no)),
    filters: (d.filters||[]).filter(isActive).sort((a,b)=>(+a.order)-(+b.order)),
    beds: (d.beds||[]),
    accessories: (d.accessories||[]),
    compatMap,
    filesBase: d.filesBase || "",
    filterValueLabels: d.filterValueLabels || [],
    categoryLabels: d.categoryLabels || [],
  };
}

function initFilters(){
  filters = {};
  DATA.filters.forEach(f=> filters[f.filter_key]="");
  autoAdvance();
  // Open standaard met het eerste PASSENDE bed, zodat er meteen iets te zien
  // is in plaats van een leeg voorbeeldvlak.
  const passend = DATA.beds.filter(bedMatchesFilters);
  selectedBed = pickBed(passend) || (DATA.beds.length ? DATA.beds[0] : null);
  selectedAcc = {};
  geenKeuze = {};
  currentSub = 0;
  selectedSubAcc = {};
  subAccQty = {};
}

/* =====================================================================
   HELPERS
   ===================================================================== */
// Formatteert een bedrag in de valuta van de markt, met de juiste opmaak
// per taal (bv. "kr 11.599,00" of "€449,00").
function money(v, cur){
  if (v == null || v === "") return "";
  const n = Number(v);
  if (!isFinite(n)) return "";
  const currency = cur || CURRENCY || "";
  const loc = (window.BED_CONFIGURATOR_SETTINGS && window.BED_CONFIGURATOR_SETTINGS.locale) || LOCALE || "en";
  if (!currency) return n.toFixed(2);
  try {
    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency,
      minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return currency + " " + n.toFixed(2);
  }
}

// Zoekt een item (bed of accessoire) op SKU op.
function findBySku(sku){
  // Specificaties tonen we alleen bij de accessoires (stap 2 en verder).
  return DATA.accessories.find(a=>a.sku===sku) || null;
}
/* --- Ligvlakken ---
   De breedtekolom van het bed vertelt hoeveel matrassen er nodig zijn:
   "90" is een ligvlak, "90 & 120" en "90 & 90" zijn er twee. De maat van een
   categorie staat in de naam ("Mattress 90x200" -> 90), dus daar is geen
   extra kolom voor nodig. */
const WIDTH_FILTER_KEY = "filter_width";

function sleepSurfaces(bed){
  const b = bed || selectedBed;
  if (!b) return [];
  const basis = String(b[WIDTH_FILTER_KEY] || "").split("&").map(x => x.trim()).filter(Boolean);
  // Bed met een logeerbed erin (12 okt 2026): het logeerbed is een extra
  // ligvlak, vooraan de lijst (index 0). Het bed zelf blijft dus op de
  // plek die het had, en de schermvolgorde (index 1 eerst, dan 0) toont
  // eerst het bed en daarna het logeerbed.
  const g = gastBreedte(b);
  return g ? [g, ...basis] : basis;
}

/* --- Logeerbed als eigen ligvlak (12 okt 2026) ---
   Een bed met een ingebouwd logeerbed (bv. 47109 en 27109) heeft twee
   ligvlakken, net als een stapelbed. Hoe weet de configurator dat? Uit de
   data zelf: een accessoire waarvan de categorie met "Guest bed " begint
   (bv. "Guest bed mattress 90x200") en dat bij dit bed past. Geen aparte
   instelling bij het bed nodig. Zo'n categorie verschijnt alleen op het
   scherm van het logeerbed; en vervangt daar de gewone categorie met
   dezelfde naam zonder voorvoegsel ("Mattress 90x200"). Alle andere
   categorieen (hoeslaken, dekbedovertrek) gelden gewoon voor beide vlakken. */
const GAST_VOORVOEGSEL = /^guest bed\s+/i;
function isGastCat(cat){ return GAST_VOORVOEGSEL.test(String(cat || "")); }
function gastBreedte(bed){
  if (!bed || typeof DATA === "undefined" || !DATA || !DATA.accessories || !DATA.compatMap) return null;
  const items = DATA.accessories.filter(a => isGastCat(a.category) && accCompatibleWithBed(a, bed.sku));
  if (!items.length) return null;
  for (const a of items) { const w = categoryWidth(a.category); if (w) return w; }
  return String(bed[WIDTH_FILTER_KEY] || "").split("&")[0].trim() || null;
}
function heeftGastVlak(bed){ return gastBreedte(bed || selectedBed) !== null; }
// Gewone categorieen die op het logeerbed vervangen worden door een eigen
// "Guest bed ..."-categorie (bv. "mattress 90x200").
function gastTegenhangers(){
  const set = new Set();
  ((typeof DATA !== "undefined" && DATA && DATA.accessories) || []).forEach(a => {
    if (isGastCat(a.category)) set.add(String(a.category).replace(GAST_VOORVOEGSEL, "").trim().toLowerCase());
  });
  return set;
}

// "Mattress 90x200" -> "90";  "Duvet cover" -> null
function categoryWidth(cat){
  const m = String(cat || "").match(/(\d+)\s*[x×]\s*\d+/i);
  return m ? m[1] : null;
}

function slotLabel(i, aantal){
  if (heeftGastVlak()) {
    if (i === 0) return t("slotGuest");
    if (aantal === 2) return t("slotBedOnly");
    return t("slotOther", { n: i + 1 });
  }
  if (aantal === 2) return i === 0 ? t("slotTop") : t("slotBottom");
  return t("slotOther", { n: i + 1 });
}

/* --- Verplichte keuze en losse schermen per ligvlak (5 okt 2026) ---
   Stap met "Moet kiezen" (metaobject Configurator step, veld must_choose):
   de klant moet in elke ligvlak-categorie iets kiezen, en dat mag ook bewust
   "Geen" zijn. Dit staat los van het veld "Verplicht" op een product. */
function stapMoetKiezen(step){
  return !!step && String(step.must_choose || "").toLowerCase() === "yes";
}
function geenKey(stepNo, cat, slot){
  return `${stepNo}|${cat}|${(slot === null || slot === undefined) ? "" : slot}`;
}
function isGeenGekozen(stepNo, cat, slot){
  return !!geenKeuze[geenKey(stepNo, cat, slot)];
}

// Artikelen van deze stap die bij het gekozen bed passen (ook niet-leverbare).
function stapItems(stepNo){
  return DATA.accessories.filter(a => String(a.step_no) === String(stepNo) &&
    (!selectedBed || accCompatibleWithBed(a, selectedBed.sku)));
}

// Voor welke categorieen geldt "Moet kiezen"? Alleen de categorieen met een
// maat (de ligvlakken). Heeft het bed een enkel ligvlak, dan alleen de
// categorie van die breedte. Zonder maten in de stap: alle categorieen.
// Is "Moet kiezen" uit, dan is de lijst leeg.
function plichtCategorieen(step, cats, vlakken){
  if (!stapMoetKiezen(step)) return [];
  const metMaat = cats.filter(c => categoryWidth(c));
  let lijst = metMaat.length ? metMaat : cats.slice();
  if (vlakken.length === 1) {
    const pas = lijst.filter(c => categoryWidth(c) === vlakken[0]);
    if (pas.length) lijst = pas;
  }
  return lijst;
}

/* In welke volgorde krijgt de klant de ligvlakken te zien? Bij een bed met
   twee ligvlakken eerst het onderbed (index 1), dan het bovenbed (index 0).
   [null] = geen losse schermen: de hele stap staat op een scherm. */
function stapSchermen(stepNo){
  const step = DATA.steps.find(st => String(st.step_no) === String(stepNo));
  if (!step || String(step.step_no) === "1" || String(step.type).toLowerCase() === "slats") return [null];
  const metMaat = [...new Set(stapItems(stepNo).map(i => i.category))].filter(c => categoryWidth(c));
  const vlakken = sleepSurfaces();
  if (vlakken.length < 2 || !metMaat.length) return [null];
  const volgorde = vlakken.length === 2 ? [1, 0] : vlakken.map((_, i) => i);
  return volgorde.filter(i => metMaat.some(c => categoryWidth(c) === vlakken[i]));
}
function aantalSchermen(stepNo){
  return Math.max(1, stapSchermen(stepNo).length);
}

/* Een stap met maat-categorieen ("Fitted sheet 90x200") is een stap per
   ligvlak (zoals Beddengoed). Een categorie zonder maat in zo'n stap
   (dekbedovertrek) kiest de klant dan ook per ligvlak: een eigen overtrek op
   het onderbed en op het bovenbed. In andere stappen (dak, gordijn, ...)
   blijft zo'n categorie voor het bed als geheel. */
function stapPerVlak(stepNo){
  return stapItems(stepNo).some(a => categoryWidth(a.category));
}
function perVlakCat(cat, stepNo){
  return !!categoryWidth(cat) || stapPerVlak(stepNo);
}
// Past deze categorie bij ligvlak i? Zonder maat in de naam: bij elk ligvlak.
function vlakPast(cat, i, vlakken){
  const heeftGast = heeftGastVlak();
  const isGast = isGastCat(cat);
  if (isGast && !(heeftGast && i === 0)) return false;           // alleen op het logeerbed
  if (heeftGast && i === 0 && !isGast &&
      gastTegenhangers().has(String(cat || "").trim().toLowerCase())) return false;   // vervangen door de eigen categorie
  const w = categoryWidth(cat);
  return w ? w === vlakken[i] : true;
}

/* Liquid weet niet of configurator_{SKU}.webp bestaat, dus we krijgen twee
   URL's mee. We proberen de configuratorfoto en vallen bij een 404 terug op
   de gewone productfoto. Bij de backend is er maar één URL en verandert er
   niets. */
/* Sommige bedden zijn op meerdere manieren te monteren en hebben daarom
   extra foto's: configurator_{SKU}-2.webp t/m -6.webp. Liquid kan niet zien
   welke bestaan, dus de frontend biedt ze als duimnagels aan; een foto die
   niet bestaat verdwijnt vanzelf via onerror (zie fotoTerugval hieronder). */
const MAX_EXTRA_FOTOS = 4;   // jullie hebben er nu maximaal 4; hier op te hogen

// Alle MOGELIJKE bestandsnamen (nog niet bevestigd dat ze bestaan).
function fotoKandidaten(bed){
  const sh = (bed && bed.shopify) || {};
  const basis = sh.configuratorImage;
  if (!basis || !bed.sku) return [];
  const punt = basis.lastIndexOf(".");
  if (punt === -1) return [];
  const stam = basis.slice(0, punt), ext = basis.slice(punt);
  const uit = [{ n: 0, src: basis }];
  for (let n = 2; n <= MAX_EXTRA_FOTOS; n++) uit.push({ n, src: `${stam}-${n}${ext}` });
  return uit;
}

// Alleen de varianten die BEVESTIGD bestaan (hoofdbeeld telt altijd mee).
// Dit is wat er getekend wordt; fotoKandidaten is alleen om te testen.
function fotoVarianten(bed){
  const kand = fotoKandidaten(bed);
  if (!kand.length) return [];
  const bevestigd = bevestigdeFotos[bed.sku] || new Set();
  return kand.filter(v => v.n === 0 || bevestigd.has(v.n));
}

// Test op de achtergrond, onzichtbaar, of de extra foto's van dit bed
// bestaan. Wordt één keer per SKU gedaan; het resultaat blijft bewaard.
function testFotoVarianten(bed){
  if (!bed || !bed.sku) return;
  if (typeof Image === "undefined") return;   // geen browseromgeving
  if (bevestigdeFotos[bed.sku]) return;   // al getest (of bezig)
  bevestigdeFotos[bed.sku] = new Set();
  const kand = fotoKandidaten(bed).filter(v => v.n !== 0);
  kand.forEach(v => {
    const proef = new Image();
    proef.onload = () => fotoBevestigd(bed.sku, v.n);
    proef.onerror = () => {};   // bestaat niet: gewoon negeren
    proef.src = v.src;
  });
}

function kiesFoto(n){
  actieveFoto = Number(n) || 0;
  render();
}

// Wordt aangeroepen zodra een duimnagelfoto ECHT geladen is. Pas dan weten we
// zeker dat hij bestaat, en tonen we de rij (voorkomt onnodige 404's bij elk
// gewoon bed met maar één foto).
function fotoBevestigd(sku, n){
  if (!bevestigdeFotos[sku]) bevestigdeFotos[sku] = new Set();
  if (bevestigdeFotos[sku].has(n)) return;   // al bekend, niet opnieuw tekenen
  bevestigdeFotos[sku].add(n);
  render();
}

function fotoVan(item){
  const sh = (item && item.shopify) || {};
  return sh.configuratorImage || sh.image || "";
}
function fotoTerugval(item){
  const sh = (item && item.shopify) || {};
  return (sh.configuratorImage && sh.image) ? sh.image : "";
}
// onerror-afhandeling: eerst de terugval proberen, daarna pas opgeven.
function fotoOnError(item, klasseLeeg){
  const terug = fotoTerugval(item);
  const leeg = `this.replaceWith(Object.assign(document.createElement('div'),{className:'${klasseLeeg}'}))`;
  if (!terug) return leeg;
  // Let op: enkele aanhalingstekens. Het onerror-attribuut staat zelf tussen
  // dubbele; een dubbele quote hierbinnen breekt het attribuut af.
  const url = String(terug).replace(/'/g, "\\'");
  return `if(!this.dataset.tweede){this.dataset.tweede=1;this.src='${url}';}else{${leeg}}`;
}

function hasSpecs(item){
  return !!(item && item.shopify && item.shopify.specifications);
}

/* Staat dit artikel in de webshop? Zo niet, dan weigert de winkelmand het
   ("Cannot find variant"), dus laten we het niet kiezen. Zet je een product
   in Shopify tijdelijk van Online Store af, dan komt het hier vanzelf uit. */
function isAvailable(item){
  if (!item) return false;
  if (!item.shopify) return false;          // SKU niet gevonden in Shopify
  return item.shopify.publishedOnline !== false;
}

// Heeft dit item een prijs in de huidige markt?
function hasPrice(item){
  const p = item && item.shopify ? item.shopify.price : null;
  if (p === null || p === undefined || p === "") return false;
  // 0 betekent "niet te koop in deze markt", geen gratis product.
  return Number(p) > 0;
}

// Valuta zoals die uit de backend komt (per markt).
let CURRENCY = null;
function detectCurrency(d){
  const first = (d.beds || []).find(b => b.shopify && b.shopify.currency)
             || (d.accessories || []).find(a => a.shopify && a.shopify.currency);
  return first ? first.shopify.currency : null;
}
/* ---------------- Compatibiliteitsregels ----------------
   Kwam uit de backend; draait nu hier, op dezelfde manier.
   De cel accepteert drie soorten waarden, door elkaar en komma-gescheiden:
     4630-10, ELEM-04                        losse SKU's
     ALL                                     alle bedden
     filter_width:90                         alle bedden met die waarde
     filter_width:90|120                     de ene waarde OF de andere
     filter_style:Original & filter_width:90 beide voorwaarden tegelijk        */

function vindKolom(kolommen, naam){
  const wil = String(naam).trim().toLowerCase();
  if (!wil) return null;
  return kolommen.find(c => c.toLowerCase() === wil)
      || kolommen.find(c => c.toLowerCase() === "filter_" + wil)
      || null;
}

function leesRegel(regel, kolommen){
  let delen = String(regel).split("&").map(x => x.trim()).filter(Boolean);
  // Een waarde mag zelf een & bevatten ("Black & White"): dan niet splitsen.
  if (delen.length > 1 && !delen.every(d => d.includes(":"))) delen = [String(regel).trim()];

  const voorwaarden = [];
  for (const deel of delen) {
    const i = deel.indexOf(":");
    if (i === -1) return { fout: `"${deel}" mist een dubbele punt` };
    const naam = deel.slice(0, i).trim();
    const kol = vindKolom(kolommen, naam);
    if (!kol) return { fout: `kolom "${naam}" bestaat niet` };
    const waarden = deel.slice(i + 1).split("|").map(v => v.trim().toLowerCase()).filter(Boolean);
    if (!waarden.length) return { fout: `geen waarde achter "${naam}:"` };
    voorwaarden.push({ kol, waarden });
  }
  return { voorwaarden };
}

function beddenVoorRegel(regel, bedden, kolommen){
  const g = leesRegel(regel, kolommen);
  if (g.fout) return g;
  const skus = bedden
    .filter(b => g.voorwaarden.every(v =>
      cellValues(b[v.kol]).some(x => v.waarden.includes(x.toLowerCase()))))
    .map(b => (b.sku || "").trim().toUpperCase())
    .filter(Boolean);
  return { skus: [...new Set(skus)] };
}

// Zet de rauwe regels van alle accessoires om naar een SKU-lijst per accessoire.
function bouwCompatMap(accessoires, bedden){
  const kolommen = [...new Set(bedden.flatMap(b => Object.keys(b)))];
  const map = {};
  const problemen = [];

  for (const acc of accessoires) {
    const sku = (acc.sku || "").trim().toUpperCase();
    if (!sku) continue;
    const cel = acc.compatible_with_sku || acc.compatible_with || "";
    const stukken = cellValues(cel);

    if (stukken.some(x => x.toUpperCase() === "ALL")) { map[sku] = "ALL"; continue; }

    const uit = new Set();
    for (const stuk of stukken) {
      if (!stuk.includes(":")) { uit.add(stuk.toUpperCase()); continue; }
      const res = beddenVoorRegel(stuk, bedden, kolommen);
      if (res.fout) { problemen.push(`${sku} · ${stuk} → ${res.fout}`); continue; }
      if (!res.skus.length) problemen.push(`${sku} · ${stuk} → geen enkel bed voldoet`);
      res.skus.forEach(x => uit.add(x));
    }
    map[sku] = [...uit];
  }
  if (problemen.length) console.warn("Compatibiliteitsregels met een probleem:\n" + problemen.join("\n"));
  return map;
}

/* ---------------- Afhankelijkheden tussen accessoires ----------------
   Het metafield configurator.requires op de variant bevat de SKU('s) waar dit
   artikel van afhangt. Voorbeeld: het rugpaneel 7821 vereist het dak 7820.
   - kiest de klant 7821, dan wordt 7820 er automatisch bij gekozen
   - verdwijnt 7820 (verwijderd of vervangen), dan gaat 7821 mee
   - is 7820 niet beschikbaar bij dit bed, dan staat 7821 gedimd met een uitleg
   Meerdere SKU's mogen, komma-gescheiden; dan moeten ze allemaal gekozen zijn. */

function vereistenVan(acc){
  return cellValues(acc && acc.requires).map(x => x.trim().toUpperCase()).filter(Boolean);
}

// Is deze SKU op dit moment gekozen (in welk ligvlak dan ook)?
function isGekozen(sku){
  return Object.keys(selectedAcc).some(k => skuOfKey(k).toUpperCase() === String(sku).toUpperCase());
}

// Bestaat de vereiste SKU, past hij bij dit bed en is hij leverbaar?
function vereisteBruikbaar(sku){
  const item = DATA.accessories.find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  if (!item) return null;
  if (!isAvailable(item)) return null;
  if (selectedBed && !accCompatibleWithBed(item, selectedBed.sku)) return null;
  return item;
}

// Alle vereisten van dit artikel bruikbaar? Zo niet: welke ontbreekt er?
function ontbrekendeVereiste(acc){
  for (const sku of vereistenVan(acc)) {
    if (!vereisteBruikbaar(sku)) return sku;
  }
  return null;
}

// Naam om in de melding te tonen; valt terug op de SKU.
function naamVanSku(sku){
  const item = DATA.accessories.find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  return (item && item.shopify && item.shopify.title) || sku;
}

// Kies de vereisten er automatisch bij. Werkt door in een keten en kan niet
// in een kringetje blijven hangen.
function kiesVereistenBij(acc, gezien){
  gezien = gezien || new Set();
  for (const sku of vereistenVan(acc)) {
    if (gezien.has(sku)) continue;
    gezien.add(sku);
    if (isGekozen(sku)) continue;
    const item = vereisteBruikbaar(sku);
    if (!item) continue;
    kiesIntern(item, 1, null);
    kiesVereistenBij(item, gezien);
  }
}

// Ruimt keuzes op waarvan de vereiste inmiddels weg is. Herhaalt tot er niets
// meer verandert, zodat ook ketens netjes aflopen.
function handhaafVereisten(){
  let veranderd = true;
  while (veranderd) {
    veranderd = false;
    for (const key of Object.keys(selectedAcc)) {
      const acc = selectedAcc[key];
      const mist = vereistenVan(acc).some(sku => !isGekozen(sku));
      if (mist) { delete selectedAcc[key]; delete accQty[key]; veranderd = true; }
    }
  }
}

/* ---------------- Sub-accessoires (12 sep 2026) ----------------
   Bewust het OMGEKEERDE van "requires" hierboven: een sub-accessoire wordt
   NOOIT automatisch gekozen, maar wordt pas als extra, optionele keuze
   GETOOND zodra zijn "ouder" gekozen is (bv. een matras die alleen te
   kiezen is als het logeerbed al gekozen is). Kiest de klant hem niet, dan
   gebeurt er niets; verdwijnt de ouder (verwijderd of vervangen door iets
   anders uit dezelfde categorie), dan vervalt een eventueel gekozen
   sub-accessoire automatisch mee. Het metafield configurator.sub_accessory_of
   op de sub-accessoire-variant bevat de ouder-SKU('s), komma-gescheiden
   (net als "requires"), bv. "7049-10, 7049-01W" voor beide kleuren van
   hetzelfde logeerbed. Generiek genoeg voor een volgend, vergelijkbaar
   geval later -- niet hardcoded aan één SKU gekoppeld. */
function subAccessoryOf(acc){
  // Een ouder mag een bed-regel achter zich hebben: "7049-10@filter_width:90".
  // Voor alle bestaande logica telt alleen het SKU-deel (voor de @).
  return cellValues(acc && acc.sub_accessory_of)
    .map(x => x.split("@")[0].trim().toUpperCase()).filter(Boolean);
}
/* Bed-regel bij een ouder (12 okt 2026, afdekplaten 7052 / 70512 / 70514):
   "7049-10@filter_width:90|90 & 90" = alleen tonen als het gekozen bed die
   waarde heeft. Zelfde regelsyntax als compatible_with. Zonder "@..." geldt
   geen beperking (de matrassen, dus niets verandert). */
function subAccBedRegel(acc, ouderSku){
  const doel = String(ouderSku).trim().toUpperCase();
  for (const x of cellValues(acc && acc.sub_accessory_of)) {
    const i = x.indexOf("@");
    const sku = (i === -1 ? x : x.slice(0, i)).trim().toUpperCase();
    if (sku === doel) return i === -1 ? "" : x.slice(i + 1).trim();
  }
  return "";
}
function subAccPastBijOuder(acc, ouderSku){
  const regel = subAccBedRegel(acc, ouderSku);
  if (!regel || !selectedBed) return true;
  const bedden = DATA.beds || [];
  const kolommen = [...new Set(bedden.flatMap(b => Object.keys(b)))];
  const res = beddenVoorRegel(regel, bedden, kolommen);
  if (res.fout) { console.warn(`Bed configurator: sub-accessoire ${acc.sku}: ${res.fout}`); return false; }
  return res.skus.includes(String(selectedBed.sku || "").trim().toUpperCase());
}
function subAccessoriesVoor(ouderSku){
  const doel = String(ouderSku).trim().toUpperCase();
  return (DATA.accessories || []).filter(a => subAccessoryOf(a).includes(doel) && subAccPastBijOuder(a, doel));
}
function isGekozenSubAcc(sku){
  return !!selectedSubAcc[String(sku).trim().toUpperCase()];
}
// Hoeveel stuks staat er nu gekozen van deze sub-accessoire (minimaal 1,
// zelfde plafond MAX_QTY als bij gewone accessoires).
function qtyOfSubAcc(key){
  return Math.min(MAX_QTY, Math.max(1, subAccQty[key] || 1));
}
// Ruimt andere gekozen sub-accessoires op die met "acc" overlappen: zelfde
// ouder(s) EN zelfde categorie (10 sep 2026, was: alle sub-accessoires van
// dezelfde ouder, ongeacht categorie). Zo blijft er per categorie hoogstens
// één sub-accessoire gekozen (bv. één dak), maar een dak- en een
// rugpaneel-keuze onder dezelfde ouder-optie kunnen nu wel samen gekozen
// staan -- nodig voor de "House Construction H128 cm"-optie (6371-090),
// die net als de bestaande 47611-bedden een dak-keuze EN een losse
// rugpaneel-keuze als sub-accessoire aanbiedt.
function maakPlaatsVoorSubAcc(acc){
  const ouders = subAccessoryOf(acc);
  Object.keys(selectedSubAcc).forEach(k => {
    const overig = selectedSubAcc[k];
    if (String(overig.sku).toUpperCase() === String(acc.sku).toUpperCase()) return;
    if (overig.category !== acc.category) return;
    const overigeOuders = subAccessoryOf(overig);
    if (overigeOuders.some(o => ouders.includes(o))) {
      delete selectedSubAcc[k];
      delete subAccQty[k];
    }
  });
}
/* Kiest automatisch de "vereiste partner" van een sub-accessoire erbij, bv.
   rugpaneel 7821 vereist dak 7820 (metafield configurator.requires, zelfde
   veld als bij gewone accessoires -- zie kiesVereistenBij hierboven). Dit
   telt hier ALLEEN als die partner zelf ook een sub-accessoire is van (een
   van) dezelfde ouder(s); is dat niet zo, dan is het een gewone,
   top-level vereiste en regelt kiesVereistenBij dat al. */
function kiesSubAccVereistenBij(acc, gezien){
  gezien = gezien || new Set();
  const ouders = subAccessoryOf(acc);
  for (const sku of vereistenVan(acc)) {
    if (gezien.has(sku)) continue;
    gezien.add(sku);
    const partner = (DATA.accessories || []).find(a => String(a.sku).toUpperCase() === sku);
    if (!partner || !isAvailable(partner)) continue;
    if (!subAccessoryOf(partner).some(o => ouders.includes(o))) continue;
    const pkey = String(partner.sku).trim().toUpperCase();
    if (!selectedSubAcc[pkey]) {
      maakPlaatsVoorSubAcc(partner);
      selectedSubAcc[pkey] = partner;
      subAccQty[pkey] = Math.min(maxQtyFor(partner), 1);
    }
    kiesSubAccVereistenBij(partner, gezien);
  }
}
// Ruimt sub-accessoires op waarvan de vereiste partner (zie hierboven)
// niet meer gekozen staat -- bv. dak wordt gewisseld van Panda naar
// Rabbit, dan vervalt het bijpassende Panda-rugpaneel automatisch mee.
// Herhaalt tot er niets meer verandert (zelfde stijl als handhaafVereisten).
function handhaafSubAccVereisten(){
  let veranderd = true;
  while (veranderd) {
    veranderd = false;
    for (const key of Object.keys(selectedSubAcc)) {
      const acc = selectedSubAcc[key];
      const ouders = subAccessoryOf(acc);
      const mist = vereistenVan(acc).some(sku => {
        const partner = (DATA.accessories || []).find(a => String(a.sku).toUpperCase() === sku);
        if (!partner) return false;
        if (!subAccessoryOf(partner).some(o => ouders.includes(o))) return false;
        return !isGekozenSubAcc(sku);
      });
      if (mist) { delete selectedSubAcc[key]; delete subAccQty[key]; veranderd = true; }
    }
  }
}
// Kiest deze sub-accessoire in dit aantal (max_qty bepaalt hoeveel
// kaartjes -- 1x, 2x, ... -- er getoond worden, zie renderSubAccCards).
// Nogmaals op hetzelfde aantal klikken zet de keuze weer uit.
function chooseSubAcc(sku, aantal){
  const acc = (DATA.accessories || []).find(a => String(a.sku).toUpperCase() === String(sku).toUpperCase());
  if (!acc || !isAvailable(acc)) return;
  const key = String(sku).trim().toUpperCase();
  const n = Math.min(maxQtyFor(acc), Math.max(1, Number(aantal) || 1));

  if (selectedSubAcc[key] && qtyOfSubAcc(key) === n) {
    delete selectedSubAcc[key];
    delete subAccQty[key];
    handhaafSubAccVereisten();
    render();
    return;
  }
  maakPlaatsVoorSubAcc(acc);
  selectedSubAcc[key] = acc;
  subAccQty[key] = n;
  kiesSubAccVereistenBij(acc);
  handhaafSubAccVereisten();
  render();
}
// Aantal bijstellen vanuit de rechterkolom (alleen zichtbaar bij max_qty > 1).
function changeSubAccQty(key, delta){
  if (!selectedSubAcc[key]) return;
  subAccQty[key] = Math.min(MAX_QTY, Math.max(1, qtyOfSubAcc(key) + delta));
  render();
}
function removeSubAcc(key){
  delete selectedSubAcc[key];
  delete subAccQty[key];
  handhaafSubAccVereisten();
  render();
}
// Ruimt een gekozen sub-accessoire op zodra GEEN van zijn ouders meer
// gekozen is (bv. het logeerbed is verwijderd of vervangen door de grote
// bedlade uit dezelfde categorie).
function handhaafSubAccessoires(){
  Object.keys(selectedSubAcc).forEach(key => {
    const acc = selectedSubAcc[key];
    const ouders = subAccessoryOf(acc);
    const nogGekozen = ouders.some(sku => isGekozen(sku) && subAccPastBijOuder(acc, sku));
    if (!nogGekozen) { delete selectedSubAcc[key]; delete subAccQty[key]; }
  });
  handhaafSubAccVereisten();
}

/* ---------------- Vertaalde filterwaarden ----------------
   "Original", "White", "None" komen ongewijzigd uit de metafields en blijven
   dat ook overal in de logica -- alleen wat de klant LEEST wordt vervangen
   door het label, als dat er is. Ontbreekt een vertaling, dan tonen we de
   rauwe waarde en waarschuwen we één keer per waarde in de console. */
const gewaarschuwdeWaarden = new Set();

function waardeLabel(filterKey, waarde){
  const lijst = (DATA && DATA.filterValueLabels) || [];
  const gevonden = lijst.find(v =>
    v.filter_key === filterKey && String(v.key).toLowerCase() === String(waarde).toLowerCase());
  if (gevonden && gevonden.label) return gevonden.label;

  const sleutel = filterKey + ":" + waarde;
  if (lijst.length && !gewaarschuwdeWaarden.has(sleutel)) {
    gewaarschuwdeWaarden.add(sleutel);
    console.warn(`Bed configurator: geen vertaling voor ${filterKey}:"${waarde}". ` +
                 `Maak een entry aan in het metaobject Configurator value.`);
  }
  return waarde;
}

/* ---------------- Vertaalde categorienamen ----------------
   "Mattress 90x200" blijft overal de sleutel -- ook het ligvlak-getal wordt
   daaruit gehaald (zie categoryWidth), nooit uit de vertaling. Alleen de KOP
   boven de kaartjes toont het label, als dat er is. */
function categoryLabel(cat){
  const lijst = (DATA && DATA.categoryLabels) || [];
  const gevonden = lijst.find(c => String(c.key).toLowerCase() === String(cat).toLowerCase());
  if (gevonden && gevonden.label) return gevonden.label;

  if (lijst.length && !gewaarschuwdeWaarden.has("cat:" + cat)) {
    gewaarschuwdeWaarden.add("cat:" + cat);
    console.warn(`Bed configurator: geen vertaling voor categorie "${cat}". ` +
                 `Maak een entry aan in het metaobject Configurator category.`);
  }
  return cat;
}

function accCompatibleWithBed(acc, bedSku){
  const c = DATA.compatMap[(acc.sku||"").trim().toUpperCase()];
  if(!c) return false;
  const target = (bedSku||"").trim().toUpperCase();
  return c==="ALL" || c.includes(target);
}
// Het bovenste filter (laagste 'order' in de Sheet) is het startpunt:
// die opties zijn altijd kiesbaar en een keuze wist de overige filters.
// Heeft deze stap iets te kiezen voor het gekozen bed?
// Stap 1 (de bedkeuze) telt altijd mee.
function stepHasContent(step){
  const n = String(step.step_no);
  if (n === "1") return true;
  if (!selectedBed) return true;          // nog geen bed gekozen: toon alles
  // De lattenbodemstap alleen tonen als er echt iets te kiezen valt.
  if (String(step.type).toLowerCase() === "slats") return slatOptions().length > 1;
  return DATA.accessories.some(a =>
    String(a.step_no) === n && accCompatibleWithBed(a, selectedBed.sku));
}

// De stappen die de klant daadwerkelijk doorloopt. Lege stappen worden
// overgeslagen, zodat er nooit "geen accessoires beschikbaar" in beeld komt.
function activeSteps(){
  return DATA.steps.filter(stepHasContent);
}

// Waarschuwing in de console als een stap met een VERPLICHTE categorie wordt
// overgeslagen. Voor de klant onzichtbaar, maar zo zie je bij het testen of
// er compatibiliteit ontbreekt in de Google Sheet.
let laatsteWaarschuwing = "";
function waarschuwOverVerplichteStappen(){
  if (!selectedBed) return;
  const overgeslagen = DATA.steps
    .filter(st => !stepHasContent(st))
    .filter(st => DATA.accessories.some(a =>
      String(a.step_no) === String(st.step_no) &&
      String(a.required).toLowerCase() === "yes"));
  if (!overgeslagen.length) return;
  const sleutel = selectedBed.sku + "|" + overgeslagen.map(s=>s.step_no).join(",");
  if (sleutel === laatsteWaarschuwing) return;   // niet blijven herhalen
  laatsteWaarschuwing = sleutel;
  console.warn(
    `Bed ${selectedBed.sku}: stap(pen) ${overgeslagen.map(s=>s.step_no).join(", ")} ` +
    `bevatten een VERPLICHTE categorie, maar er is geen compatibel product. ` +
    `Controleer het tabblad Compatibility.`);
}

/* --- Verplichte keuzes ---
   Een categorie is verplicht als er in de Sheet bij minstens één artikel
   required=yes staat. Bij een bed met twee ligvlakken geldt dat per ligvlak:
   boven én onder moeten dan allebei een keuze hebben. */
function missingRequired(stepNo, alleenSlot){
  const step = DATA.steps.find(st => String(st.step_no) === String(stepNo));
  if (!step) return [];
  if (String(step.step_no) === "1") return [];
  if (String(step.type).toLowerCase() === "slats") return [];

  // Alleen leverbare artikelen tellen mee. Is in een verplichte categorie
  // niets te koop, dan mag de klant daar niet op vastlopen.
  const items = DATA.accessories.filter(a => String(a.step_no) === String(stepNo) &&
    isAvailable(a) &&
    (!selectedBed || accCompatibleWithBed(a, selectedBed.sku)));
  if (!items.length) return [];

  const cats = [...new Set(items.map(i => i.category))];
  const vlakken = sleepSurfaces();
  // Stap met "Moet kiezen": die categorieen zijn verplicht, ook zonder dat
  // een product het vinkje "Verplicht" heeft. Anders telt het vinkje.
  const plicht = plichtCategorieen(step, cats, vlakken);
  const verplicht = cat => plicht.includes(cat) || items.some(i =>
    i.category === cat && String(i.required).toLowerCase() === "yes");
  // Gekozen = een artikel gekozen, of (bij "Moet kiezen") bewust "Geen".
  const gekozen = (cat, slot) =>
    Object.entries(selectedAcc).some(([key, a]) =>
      a.category === cat && String(a.step_no) === String(stepNo) && slotOfKey(key) === slot) ||
    (plicht.includes(cat) && isGeenGekozen(stepNo, cat, slot));

  const metMaat = cats.filter(c => categoryWidth(c));
  const gesplitst = vlakken.length > 1 && metMaat.length > 0;
  // Met een ligvlak-nummer kijken we alleen naar dat ligvlak (scherm A of B).
  const opSlot = (alleenSlot === undefined || alleenSlot === null) ? null : alleenSlot;

  const uit = [];
  if (gesplitst) {
    vlakken.forEach((breedte, i) => {
      if (opSlot !== null && opSlot !== i) return;
      cats
        .filter(c => perVlakCat(c, stepNo) && vlakPast(c, i, vlakken) && verplicht(c))
        .forEach(cat => { if (!gekozen(cat, i)) uit.push(`${categoryLabel(cat)} (${slotLabel(i, vlakken.length)})`); });
    });
    if (opSlot === null) {
      cats.filter(c => !perVlakCat(c, stepNo) && verplicht(c))
          .forEach(cat => { if (!gekozen(cat, null)) uit.push(categoryLabel(cat)); });
    }
  } else {
    cats.filter(verplicht)
        .forEach(cat => { if (!gekozen(cat, null)) uit.push(categoryLabel(cat)); });
  }
  return uit;
}

// Wat houdt de knop tegen? In de laatste stap kijken we naar ALLE stappen,
// zodat er niets vergeten wordt als de klant via de balk vooruit springt.
function blockingChoices(){
  const steps = activeSteps();
  const st = steps[currentStep - 1];
  // Op een tussenscherm (bv. het onderbed, terwijl het bovenbed nog volgt)
  // kijken we alleen naar dat ligvlak.
  if (st && !isLastScreen()) {
    const sch = stapSchermen(st.step_no);
    if (sch.length > 1 && currentSub < sch.length - 1) return missingRequired(st.step_no, sch[currentSub]);
  }
  if (currentStep < steps.length) {
    return st ? missingRequired(st.step_no) : [];
  }
  // Laatste scherm: ALLE stappen, zodat niets vergeten wordt.
  return steps.flatMap(s => missingRequired(s.step_no));
}

// Staat de klant op het allerlaatste scherm (laatste stap, laatste ligvlak)?
function isLastScreen(){
  const steps = activeSteps();
  if (currentStep < steps.length) return false;
  const st = steps[currentStep - 1];
  return !st || currentSub >= aantalSchermen(st.step_no) - 1;
}

// currentStep telt binnen de actieve stappen; zorg dat hij nooit buiten
// de lijst valt (bijv. na het wisselen van bed).
function clampStep(){
  const n = activeSteps().length;
  if (currentStep > n) currentStep = n;
  if (currentStep < 1) currentStep = 1;
  // ook het scherm binnen de stap mag nooit buiten de lijst vallen
  const st = activeSteps()[currentStep - 1];
  const m = st ? aantalSchermen(st.step_no) : 1;
  if (currentSub > m - 1) currentSub = m - 1;
  if (currentSub < 0) currentSub = 0;
}

/* =====================================================================
   LATTENBODEM
   Het lattenbodemfilter wordt in stap 1 NIET aan de klant getoond, maar
   automatisch ingevuld volgens een voorkeursvolgorde (goedkoopste eerst).
   In een aparte stap kan de klant bewust upgraden.
   ===================================================================== */
const SLAT_FILTER_KEY = "filter_slats";
// Volgorde waarin lattenbodems getoond en automatisch gekozen worden.
// Er wordt gezocht op TREFWOORD, dus "Standard - 16 curved slats" telt ook
// als "standard". Zo blijft het werken als de namen wijzigen.
const SLAT_PREFERENCE = ["standard", "premium", "deluxe"];

// Welke plek heeft deze waarde in de voorkeursvolgorde? (-1 = onbekend)
function slatRank(waarde){
  const tekst = String(waarde || "").toLowerCase();
  for (let i = 0; i < SLAT_PREFERENCE.length; i++) {
    if (tekst.includes(SLAT_PREFERENCE[i])) return i;
  }
  return -1;
}

// Wordt het lattenbodemfilter als aparte stap afgehandeld?
function slatsAsStep(){
  return DATA.steps.some(st => String(st.type).toLowerCase() === "slats");
}

// Filters die in stap 1 zichtbaar zijn (zonder de lattenbodem).
function visibleFilters(){
  if (!slatsAsStep()) return DATA.filters;
  return DATA.filters.filter(f => f.filter_key !== SLAT_FILTER_KEY);
}

// Kies de eerst beschikbare lattenbodem volgens de voorkeursvolgorde.
function autoPickSlats(){
  if (!slatsAsStep()) return;
  const beschikbaar = slatValsAvailable();
  if (!beschikbaar.length) { filters[SLAT_FILTER_KEY] = ""; return; }

  // Staat de huidige keuze er nog bij? Dan die laten staan.
  if (filters[SLAT_FILTER_KEY] &&
      beschikbaar.some(v => v.toLowerCase() === filters[SLAT_FILTER_KEY].toLowerCase())) return;

  // Kies de optie die het hoogst staat in de voorkeursvolgorde.
  const gesorteerd = [...beschikbaar].sort((a,b) => {
    const ra = slatRank(a), rb = slatRank(b);
    return (ra === -1 ? 99 : ra) - (rb === -1 ? 99 : rb);
  });
  filters[SLAT_FILTER_KEY] = gesorteerd[0];
}

// De lattenbodem-opties voor het gekozen bed: alle bedden die identiek zijn
// op alle filters BEHALVE de lattenbodem.
function slatOptions(){
  if (!selectedBed) return [];
  const anders = DATA.filters.filter(f => f.filter_key !== SLAT_FILTER_KEY);
  const kandidaten = DATA.beds.filter(b =>
    anders.every(f => String(b[f.filter_key] || "") === String(selectedBed[f.filter_key] || "")));

  const gezien = new Set();
  const uit = [];
  for (const b of kandidaten) {
    const waarde = String(b[SLAT_FILTER_KEY] || "").trim();
    if (!waarde || gezien.has(waarde.toLowerCase())) continue;
    gezien.add(waarde.toLowerCase());
    uit.push({ waarde, bed: b });
  }
  // Sorteer volgens de voorkeursvolgorde; onbekende waarden achteraan.
  uit.sort((a,b) => {
    const ra = slatRank(a.waarde), rb = slatRank(b.waarde);
    return (ra === -1 ? 99 : ra) - (rb === -1 ? 99 : rb);
  });
  return uit;
}

/* --- De trechter ---
   De filters worden van boven naar beneden doorlopen. Een filter komt pas
   vrij als alle filters erboven een keuze hebben; wat eronder staat telt
   nooit mee als beperking. Het bovenste filter (Design style) heeft niets
   boven zich en blijft daarom altijd volledig kiesbaar. */

// Een filter met "optional = yes" in het tabblad Filters doet niet mee aan de
// trechter: het wordt nooit automatisch ingevuld en houdt de filters eronder
// niet tegen. De klant kan het zelf aan- en uitzetten.
function isOptionalFilter(f){
  return /^(yes|ja|true|1)$/i.test(String(f && f.optional || "").trim());
}

// Waarden die in de Sheet "geen extra's" betekenen.
const GEEN_WAARDE = /^(none|geen|nvt|n\/a|-)$/i;

// Is dit het "kale" bed? Dat wil zeggen: bij elk optioneel filter dat de klant
// leeg heeft gelaten, heeft dit bed ook niets staan.
function isPlainForEmptyOptionals(bed){
  if (!bed) return false;
  return visibleFilters()
    .filter(f => isOptionalFilter(f) && !filters[f.filter_key])
    .every(f => {
      const vals = cellValues(bed[f.filter_key]);
      return vals.length === 0 || vals.every(v => GEEN_WAARDE.test(v));
    });
}

// Kiest uit de passende bedden. Heeft de klant een optioneel filter leeg
// gelaten, dan krijgt het bed zonder die extra's voorrang; bestaat dat niet,
// dan gewoon het eerste passende bed.
function pickBed(matches){
  return matches.find(isPlainForEmptyOptionals) || matches[0] || null;
}

// De bedden die passen bij de keuzes BOVEN positie i.
// De lattenbodem telt hier niet mee: die is voor de klant verborgen en
// wordt apart gekozen, dus hij mag de zichtbare filters niet inperken.
function bedsMatchingAbove(i){
  const boven = visibleFilters().slice(0, i);
  return DATA.beds.filter(b => boven.every(f =>
    !filters[f.filter_key] || bedHasFilterValue(b, f.filter_key, filters[f.filter_key])));
}

// Welke waarden zijn op positie i nog kiesbaar?
function valuesForFilter(i){
  const key = visibleFilters()[i].filter_key;
  const out = [];
  bedsMatchingAbove(i).forEach(b => cellValues(b[key]).forEach(v => {
    if (!out.some(x => x.toLowerCase() === v.toLowerCase())) out.push(v);
  }));
  return out;
}

// Is dit filter aan de beurt? Alleen als alles erboven ingevuld is.
// Optionele filters tellen niet mee: die mogen leeg blijven.
function filterUnlocked(i){
  return visibleFilters().slice(0, i)
    .every(f => isOptionalFilter(f) || !!filters[f.filter_key]);
}

// Welke lattenbodems horen bij de huidige keuzes? (verborgen filter)
function slatValsAvailable(){
  const zichtbaar = visibleFilters();
  const out = [];
  DATA.beds
    .filter(b => zichtbaar.every(f =>
      !filters[f.filter_key] || bedHasFilterValue(b, f.filter_key, filters[f.filter_key])))
    .forEach(b => cellValues(b[SLAT_FILTER_KEY]).forEach(v => {
      if (!out.some(x => x.toLowerCase() === v.toLowerCase())) out.push(v);
    }));
  return out;
}

// Een cel in de Sheet mag meerdere waarden bevatten, gescheiden door komma's.
// Bijvoorbeeld "Storage, Guest bed" telt als beide.
function cellValues(v){
  if (v === undefined || v === null) return [];
  return String(v).split(",").map(x => x.trim()).filter(Boolean);
}
function bedHasFilterValue(bed, key, val){
  return cellValues(bed[key]).some(x => x.toLowerCase() === String(val).trim().toLowerCase());
}

// Vaste weergavevolgorde voor sommige filters (11 sep 2026, op verzoek): de
// pillen van "Bedtype" en "Bedbreedte" tonen nu een logische volgorde in
// plaats van gewoon de volgorde waarin de bedden toevallig in Shopify staan.
// Vergelijken gaat op de ruwe Engelse waarde uit het metafield (hoofdletter-
// ongevoelig), dus dit werkt in elke taal -- de vertaalde tekst op de pil zelf
// komt nog steeds gewoon uit waardeLabel(). Een waarde die hier niet in staat
// (bv. een nieuw bedtype of een nieuwe breedte die later wordt toegevoegd)
// verdwijnt niet: die komt gewoon achteraan te staan, in de volgorde waarin
// hij voorkomt. Andere filters (Stijl, Kleur, ...) blijven ongewijzigd.
const FILTER_VALUE_ORDER = {
  filter_bedtype: [
    "floor", "4-in-1 floor", "single", "daybed", "mid sleeper 128 cm",
    "high sleeper 152 cm", "high sleeper 177 cm", "bunkbed 152 cm", "bunkbed 177 cm",
  ],
  filter_width: [
    "90", "90 & 90", "90 & 120", "90 & 140", "120", "120 & 120", "140",
  ],
};

// Rang van een waarde in de vaste volgorde van dat filter (-1 = niet
// vastgelegd -> komt achteraan).
function filterValueRank(filterKey, waarde){
  const lijst = FILTER_VALUE_ORDER[filterKey];
  if (!lijst) return -1;
  return lijst.indexOf(String(waarde || "").trim().toLowerCase());
}

function uniqueFilterVals(key){
  const out = [];
  DATA.beds.forEach(b => cellValues(b[key]).forEach(v => {
    if (!out.some(x => x.toLowerCase() === v.toLowerCase())) out.push(v);
  }));
  if (FILTER_VALUE_ORDER[key]) {
    out.sort((a, b) => {
      const ra = filterValueRank(key, a), rb = filterValueRank(key, b);
      return (ra === -1 ? 99 : ra) - (rb === -1 ? 99 : rb);
    });
  }
  return out;
}

// Zoekt het bed dat hoort bij de huidige filters plus een gegeven lattenbodem.
function bedForSlats(waarde){
  const anders = DATA.filters.filter(f => f.filter_key !== SLAT_FILTER_KEY);
  return DATA.beds.find(b =>
    String(b[SLAT_FILTER_KEY] || "").toLowerCase() === String(waarde).toLowerCase() &&
    anders.every(f => !filters[f.filter_key] || bedHasFilterValue(b, f.filter_key, filters[f.filter_key]))) || null;
}

// Klant kiest een andere lattenbodem: dat is een ander bed (andere SKU).
function chooseSlats(waarde){
  const optie = slatOptions().find(o => o.waarde.toLowerCase() === String(waarde).toLowerCase());
  if (!optie) return;
  filters[SLAT_FILTER_KEY] = optie.waarde;
  selectedBed = optie.bed;
  render();
}

// Loopt de filters van boven naar beneden af. Blijft er op een positie maar
// één mogelijkheid over, dan wordt die ingevuld en schuift de beurt door.
// Bij de eerste positie met meerdere keuzes stopt het: daar is de klant aan
// zet, en alles daaronder blijft dus op slot.
function autoAdvance(){
  const zichtbaar = visibleFilters();
  for (let i = 0; i < zichtbaar.length; i++) {
    const f = zichtbaar[i];
    // Optioneel filter: niet invullen, en de beurt gewoon doorgeven.
    if (isOptionalFilter(f)) continue;
    if (filters[f.filter_key]) continue;
    const vals = valuesForFilter(i);
    if (vals.length !== 1) break;
    filters[f.filter_key] = vals[0];
  }
  autoPickSlats();
}

function bedMatchesFilters(bed){
  return DATA.filters.every(f =>
    !filters[f.filter_key] || bedHasFilterValue(bed, f.filter_key, filters[f.filter_key]));
}

/* =====================================================================
   RENDER
   ===================================================================== */
function render(){
  clampStep();
  waarschuwOverVerplichteStappen();
  const steps = activeSteps();
  const step = steps[currentStep-1];
  if (!step) return;
  const ontbreekt = blockingChoices();
  const bedWeg = !!selectedBed && !isAvailable(selectedBed);

  let html = `<div class="stepper">` + steps.map((s,i)=>{
    const pos = i+1;
    const cls = pos<currentStep?'done':(pos===currentStep?'active':'');
    return `<div class="seg ${cls}" onclick="goToStep(${pos})"><div class="fill"></div></div>`;
  }).join('') + `</div>
  <div class="step-meta">
    <span>${t("stepOf", {n: currentStep, total: steps.length})}</span>
    <button class="restart-btn" onclick="startOver()">${t("startOver")}</button>
  </div>
  <div class="grid">
    <div class="col-left">
      <h2 class="title">${sheetText(step,"title")}</h2>
      <p class="subtitle">${sheetText(step,"subtitle")}</p>
      <div id="optionsArea">${
        String(step.step_no)==="1" ? renderStep1()
        : String(step.type).toLowerCase()==="slats" ? renderSlatsStep()
        : renderAccessoryStep(+step.step_no)
      }</div>
      ${bedWeg ? `<div class="required-note">${t("bedUnavailable")}</div>` : ``}
      ${ontbreekt.length ? `<div class="required-note">${t("chooseFirst", {list: ontbreekt.join(", ")})}</div>` : ``}
      <div class="nav-row">
        <button class="cta cta-ghost" id="prevBtn" onclick="prevStep()" ${(currentStep===1&&currentSub===0)?'style="visibility:hidden"':''}>${t("prev")}</button>
        <button class="cta" id="nextBtn" onclick="nextStep()" ${isLastScreen()?'style="display:none"':''} ${((currentStep===1&&!selectedBed)||ontbreekt.length)?'disabled':''}>${t("next")}</button>
      </div>
    </div>

    ${renderMobileBar(bedWeg, ontbreekt)}

    <div class="canvas">
      <div class="preview-area${selectedBed && fotoVarianten(selectedBed).length>1 ? ' preview-area--met-duimnagels' : ''}">
        ${(() => {
          if (selectedBed) testFotoVarianten(selectedBed);   // onzichtbaar, kost geen zichtbare rommel
          const varianten = selectedBed ? fotoVarianten(selectedBed) : [];
          const huidige = varianten.find(v => v.n === actieveFoto) || varianten[0];
          const hoofdSrc = huidige ? huidige.src : fotoVan(selectedBed);
          const hoofd = hoofdSrc
            ? `<img class="bed-photo" src="${hoofdSrc}" alt="" onerror="${
                actieveFoto !== 0
                  ? `kiesFoto(0)`   // een duimnagelfoto die toch niet bestaat: terug naar het hoofdbeeld
                  : fotoTerugval(selectedBed)
                    ? `if(!this.dataset.tweede){this.dataset.tweede=1;this.src='${fotoTerugval(selectedBed)}';}else{this.style.display='none'}`
                    : `this.style.display='none'`
              }">`
            : `<div class="bed-photo-empty"></div>`;

          if (varianten.length < 2) return hoofd;

          // Duimnagels naast het hoofdbeeld. Elke duimnagel die een 404 geeft
          // verdwijnt vanzelf; het hoofdbeeld staat er los van.
          const nagels = varianten.map(v => `
            <button class="photo-thumb ${v.n===actieveFoto?'selected':''}" onclick="kiesFoto(${v.n})" aria-label="${t('photoVariant',{n: v.n===0?1:v.n})}">
              <img src="${v.src}" alt="" loading="lazy" onerror="this.closest('.photo-thumb').remove()">
            </button>`).join('');
          return `<div class="photo-thumbs">${nagels}</div><div class="photo-main">${hoofd}</div>`;
        })()}
      </div>
      <div class="dims">${selectedBed?.shopify?.dimensions ? t("dimensions", {v: selectedBed.shopify.dimensions}) : ''}</div>
      <div class="chosen-grid">${Object.entries(selectedAcc).map(([key,a])=>`
        <div class="chosen-item">
          <button class="chosen-remove" title="${t("remove")}" aria-label="${t("remove")}" onclick="removeAcc('${key}')">&times;</button>
          ${a.shopify?.image
            ? `<img class="chosen-thumb" src="${fotoVan(a)}" alt="" loading="lazy" onerror="${fotoOnError(a,'chosen-thumb chosen-thumb--empty')}">`
            : `<div class="chosen-thumb chosen-thumb--empty"></div>`}
          <div class="chosen-label">${a.shopify?.title || a.sku}${
            slotOfKey(key) !== null
              ? `<span class="chosen-slot">${slotLabel(slotOfKey(key), sleepSurfaces().length)}</span>`
              : ``}</div>
          <div class="qty-row">
            <button class="qty-btn" title="${t("fewer")}" aria-label="${t("fewer")}" onclick="changeQty('${key}',-1)" ${qtyOf(key)<=1?'disabled':''}>&minus;</button>
            <span class="qty-num">${qtyOf(key)}×</span>
            <button class="qty-btn" title="${t("more")}" aria-label="${t("more")}" onclick="changeQty('${key}',1)" ${qtyOf(key)>=MAX_QTY?'disabled':''}>+</button>
          </div>
        </div>`).join('')}${Object.entries(selectedSubAcc).map(([key,a])=>`
        <div class="chosen-item">
          <button class="chosen-remove" title="${t("remove")}" aria-label="${t("remove")}" onclick="removeSubAcc('${key}')">&times;</button>
          ${a.shopify?.image
            ? `<img class="chosen-thumb" src="${fotoVan(a)}" alt="" loading="lazy" onerror="${fotoOnError(a,'chosen-thumb chosen-thumb--empty')}">`
            : `<div class="chosen-thumb chosen-thumb--empty"></div>`}
          <div class="chosen-label">${a.shopify?.title || a.sku}</div>
          ${maxQtyFor(a) > 1 ? `
          <div class="qty-row">
            <button class="qty-btn" title="${t("fewer")}" aria-label="${t("fewer")}" onclick="changeSubAccQty('${key}',-1)" ${qtyOfSubAcc(key)<=1?'disabled':''}>&minus;</button>
            <span class="qty-num">${qtyOfSubAcc(key)}×</span>
            <button class="qty-btn" title="${t("more")}" aria-label="${t("more")}" onclick="changeSubAccQty('${key}',1)" ${qtyOfSubAcc(key)>=MAX_QTY?'disabled':''}>+</button>
          </div>` : ``}
        </div>`).join('')}</div>
      <div class="config-row">
        <div class="config-card"><div class="config-eyebrow">${t("currentConfig")}</div><div>${renderConfigName()}</div></div>
        <button class="cta" id="cartBtn" onclick="onCartClick()" ${(!selectedBed||ontbreekt.length||bedWeg)?'disabled':''}>${cartLabel()}</button>
      </div>
    </div>
  </div>`;
  document.getElementById('app').innerHTML = html;
}

function renderStep1(){
  // Filters in een raster: bij meer filters komen er automatisch kolommen
  // bij, zodat alles zichtbaar blijft zonder te scrollen.
  const zichtbaar = visibleFilters();
  const n = zichtbaar.length;
  return `<div class="filter-grid" style="--filter-count:${n}">` + zichtbaar.map((f,i)=>{
    // Filters die nog niet aan de beurt zijn blijven zichtbaar, maar gedimd.
    const vrij = filterUnlocked(i);
    const mogelijk = vrij ? valuesForFilter(i).map(v => v.toLowerCase()) : [];
    const vals = uniqueFilterVals(f.filter_key);
    const infoBtn = infoText(f)
      ? `<button type="button" class="filter-info-btn" aria-label="${t("moreInfo")}" onclick="openFilterInfo('${f.filter_key}')"><span class="guide-icon">i</span></button>`
      : ``;
    return `<div class="group ${vrij?'':'locked'}"><div class="group-label">${f.label}${infoBtn}</div><div class="pill-row">
      ${vals.map(v=>{
        // Hoofdletterongevoelig vergelijken: de Sheet kan wisselen in schrijfwijze.
        const active = String(filters[f.filter_key]||"").toLowerCase() === String(v).toLowerCase();
        const kiesbaar = vrij && mogelijk.includes(String(v).toLowerCase());
        const cls = active?'selected':(kiesbaar?'available':'disabled');
        return `<button class="pill ${cls}" ${kiesbaar||active?'':'disabled'} onclick="toggleFilter('${f.filter_key}','${String(v).replace(/'/g,"\\'")}')">${waardeLabel(f.filter_key, v)}</button>`;
      }).join('')}
    </div></div>`;
  }).join('') + `</div>`;
}

/* --- Uitleg-popup: haalt een pagina uit de webshop op en toont die --- */
let guideCache = {};   // url -> html

function guideUrl(){
  const S = window.BED_CONFIGURATOR_SETTINGS || {};
  const pad = S.slatsGuideUrl || "";
  if (!pad) return "";
  // Respecteer het taalpad van de markt (bv. /en-dk/pages/...)
  const root = (S.routesRoot || "/").replace(/\/$/, "");
  return pad.startsWith("http") || pad.startsWith(root + "/") ? pad : root + pad;
}

/* Elke winkel-URL moet het pad van de markt meekrijgen: in de Nederlandse
   markt is /cart namelijk /nl-nl/cart. Zonder dat beland je in de winkelmand
   van de standaardmarkt, zonder prijzen. */
function winkelPad(pad){
  const S = window.BED_CONFIGURATOR_SETTINGS || {};
  const root = (S.routesRoot || "/").replace(/\/$/, "");
  return root + pad;
}

async function openGuide(){
  const url = guideUrl();
  if (!url) return;

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box" role="dialog" aria-modal="true">
      <button class="guide-close" aria-label="${t("specsClose")}">&times;</button>
      <div class="guide-content"><p>${t("guideLoading")}</p></div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => overlay.remove();
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  const esc = e => { if (e.key === "Escape") { sluit(); document.removeEventListener("keydown", esc); } };
  document.addEventListener("keydown", esc);

  const doel = overlay.querySelector(".guide-content");
  try {
    if (!guideCache[url]) {
      const r = await fetch(url);
      if (!r.ok) throw new Error("HTTP " + r.status);
      const tekst = await r.text();
      // Alleen de hoofdinhoud van de pagina overnemen.
      const doc = new DOMParser().parseFromString(tekst, "text/html");
      const kern = doc.querySelector("main") ||
                   doc.querySelector("#MainContent") ||
                   doc.querySelector(".shopify-policy__body") ||
                   doc.body;
      // Verwijder onderdelen die in een popup niet thuishoren.
      kern.querySelectorAll("header,footer,nav,script,style,form,.announcement-bar-section,.header-section")
          .forEach(el => el.remove());
      guideCache[url] = kern.innerHTML;
    }
    doel.innerHTML = guideCache[url];
  } catch (e) {
    console.error("Uitlegpagina laden mislukt:", e);
    doel.innerHTML = `<p>${t("guideError")}</p>
      <p><a href="${url}" target="_blank" rel="noopener">${t("guideOpenPage")}</a></p>`;
  }
}

// Voorkomt dat tekst uit het metaobject-veld "Info" (gewone platte tekst,
// door de winkelier zelf getypt) als HTML wordt geïnterpreteerd -- anders
// zou een toevallig getypt "<" of "&" de pop-up kunnen breken.
function escapeHtml(str){
  return String(str==null?"":str).replace(/[&<>"']/g, c => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[c]));
}

// Geeft altijd een bruikbare tekst-string terug voor het info-veld van een
// filter -- ook als er ooit weer iets anders dan platte tekst uit Shopify
// komt. Vangnet naar aanleiding van de fix van 8 sep 2026: Liquid's
// json-filter struikelde bij het meerregelige "Info"-veld (een bekende
// eigenaardigheid bij dat veldtype) en leverde toen een foutobject op in
// plaats van tekst, wat als "[object Object]" in de pop-up verscheen. Nu
// wordt zoiets stils genegeerd (geen icoontje) in plaats van getoond.
function infoText(f){
  const v = f && f.info;
  if (typeof v === "string") return v.trim() ? v : "";
  if (v && typeof v === "object" && typeof v.value === "string") return v.value;
  return "";
}

/* Info-icoontje bij een filter (8 sep 2026): legt in gewone taal uit wat het
   verschil is tussen de keuzes van dat ene filter (bv. bij "Stijl"). Tekst
   komt uit het metaobject-veld "Info" op Configurator filter; leeg veld =
   geen icoontje op het scherm (zie renderStep1). Hergebruikt dezelfde
   pop-up-opmaak (.guide-overlay/.guide-box/.guide-close) als de
   lattenbodem-uitleg en de productinfo hieronder, voor een consistente look. */
function openFilterInfo(filterKey){
  const f = ((DATA && DATA.filters) || []).find(x => x.filter_key === filterKey);
  const info = infoText(f);
  if (!f || !info) return;

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box filter-info-box" role="dialog" aria-modal="true" aria-label="${escapeHtml(f.label)}">
      <button class="guide-close" aria-label="${t("specsClose")}">&times;</button>
      <div class="guide-content">
        <h3 class="info-title">${escapeHtml(f.label)}</h3>
        <div class="filter-info-text">${escapeHtml(info).replace(/\n/g, "<br>")}</div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => { overlay.remove(); document.removeEventListener("keydown", esc); };
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  const esc = e => { if (e.key === "Escape") sluit(); };
  document.addEventListener("keydown", esc);
}

/* Productinfo als popup: grote foto, titel, specificaties en een link naar
   de productpagina. Vervangt het paneel dat onder het raster verscheen. */
function grotefotoVan(item){
  const sh = (item && item.shopify) || {};
  return sh.imageLarge || sh.image || sh.configuratorImage || "";
}
function heeftInfo(item){
  return !!(item && (grotefotoVan(item) || hasSpecs(item)));
}

function openInfo(sku){
  const item = findBySku(sku);
  if (!item) return;
  const sh = item.shopify || {};
  const foto = grotefotoVan(item);
  const titel = sh.title || item.sku;
  const specs = hasSpecs(item) ? sh.specifications : "";
  // Dealer-modus: wel beeld/titel/specificaties tonen, maar geen link naar de
  // productpagina -- die zou de klant terug naar de webshop sturen, en dat
  // is in de winkel van de dealer juist niet de bedoeling.
  const link = isDealerMode() ? "" : (sh.url || "");

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box info-box" role="dialog" aria-modal="true" aria-label="${titel.replace(/"/g,'&quot;')}">
      <button class="guide-close" aria-label="${t("specsClose")}">&times;</button>
      <div class="info-content">
        ${foto ? `<div class="info-photo"><img src="${foto}" alt="" loading="lazy"></div>` : ``}
        <div class="info-text">
          <h3 class="info-title">${titel}</h3>
          ${sh.variantTitle && sh.variantTitle !== "Default Title"
            ? `<p class="info-variant">${sh.variantTitle}</p>` : ``}
          ${hasPrice(item) ? `<p class="info-price">${money(sh.price, sh.currency)}</p>` : ``}
          ${specs ? `<div class="info-specs">${specs}</div>` : ``}
          ${link ? `<a class="info-link" href="${link}" target="_blank" rel="noopener">${t("infoProductPage")}</a>` : ``}
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => { overlay.remove(); document.removeEventListener("keydown", esc); };
  function esc(e){ if (e.key === "Escape") sluit(); }
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  document.addEventListener("keydown", esc);
}

/* Foto bij een lattenbodem. De bestandsnaam wordt afgeleid uit het getal in
   de waarde: "Premium - 23 curved slats - Extra Sturdy" -> configurator-23-slats.webp
   Bestaat het bestand niet, dan verdwijnt het fotovak vanzelf. */
function slatsFoto(waarde){
  const basis = (DATA && DATA.filesBase) || "";
  if (!basis) return "";
  const m = String(waarde).match(/(\d+)/);
  if (!m) return "";
  return basis + "configurator-" + m[1] + "-slats.webp";
}

function renderSlatsStep(){
  const opties = slatOptions();
  if (!opties.length) return `<div class="empty-note">${t("slatsNoOptions")}</div>`;

  const gids = guideUrl()
    ? `<button class="guide-btn" onclick="openGuide()">
         <span class="guide-icon">i</span>${t("slatsGuide")}
       </button>`
    : ``;

  // De goedkoopste optie is de basis; het verschil daarmee is de upgrade.
  const basis = opties.reduce((laagste, o) => {
    const p = Number(o.bed.shopify?.price || 0);
    const l = Number(laagste.bed.shopify?.price || 0);
    return (p > 0 && (l === 0 || p < l)) ? o : laagste;
  }, opties[0]);
  const basisPrijs = Number(basis.bed.shopify?.price || 0);

  return gids + `<div class="slats-list">` + opties.map(o=>{
    const gekozen = selectedBed && o.bed.sku === selectedBed.sku;
    const prijs = Number(o.bed.shopify?.price || 0);
    const verschil = prijs - basisPrijs;
    const heeftPrijs = prijs > 0 && basisPrijs > 0;

    let prijsLabel = "";
    if (heeftPrijs) {
      prijsLabel = verschil > 0
        ? `<span class="slats-plus">+ ${money(verschil, o.bed.shopify?.currency)}</span>`
        : `<span class="slats-incl">${t("slatsIncluded")}</span>`;
    }

    // Alleen echte uitleg tonen; ja/nee-velden en losse woorden negeren.
    const ruw = String(o.bed.shopify?.slatsInfo || "").trim();
    const kaal = ruw.replace(/<[^>]+>/g, "").trim();
    const uitleg = (kaal.length > 15 && !/^(true|false|ja|nee|yes|no)$/i.test(kaal)) ? ruw : "";

    const foto = slatsFoto(o.waarde);
    return `<div class="slats-option ${gekozen?'selected':''}" onclick="chooseSlats('${o.waarde.replace(/'/g,"")}')">
      ${foto ? `<div class="slats-photo"><img src="${foto}" alt="" loading="lazy" onerror="this.closest('.slats-photo').remove()"></div>` : ``}
      <div class="slats-row">
        <div class="slats-radio">${gekozen?'●':''}</div>
        <div class="slats-body">
          <div class="slats-title">${waardeLabel(SLAT_FILTER_KEY, o.waarde)}</div>
          ${uitleg ? `<div class="slats-info">${uitleg}</div>` : ``}
        </div>
        <div class="slats-price">${prijsLabel}</div>
      </div>
    </div>`;
  }).join('') + `</div>`;
}

function renderAccessoryStep(stepNo){
  const items = stapItems(stepNo);
  const cats = [...new Set(items.map(i=>i.category))];
  if(!cats.length) return `<div class="empty-note">${t("noAccessories")}</div>`;

  const step = DATA.steps.find(st => String(st.step_no) === String(stepNo));
  const vlakken = sleepSurfaces();
  const plicht = plichtCategorieen(step, cats, vlakken);
  // Categorieën met een maat in de naam horen bij één ligvlak; de rest
  // (dekbedovertrek, dak, ...) geldt voor het bed als geheel.
  const metMaat = cats.filter(c => categoryWidth(c));
  const zonderMaat = cats.filter(c => !perVlakCat(c, stepNo));

  // Eén ligvlak, of niets met een maat: gewoon alle categorieën onder elkaar.
  if (vlakken.length < 2 || !metMaat.length) {
    return cats.map(cat => renderCatGroup(cat, items, null, plicht.includes(cat))).join('');
  }

  // Twee of meer ligvlakken: elk ligvlak krijgt een eigen scherm (A/B). Bij
  // een stapelbed eerst het onderbed, dan het bovenbed.
  vlakken.forEach((breedte) => {
    if (!metMaat.some(c => categoryWidth(c) === breedte)) {
      console.warn(`Bed ${selectedBed?.sku}: geen categorie van ${breedte} cm in stap ${stepNo}. ` +
                   `Controleer de Compatibility-tab.`);
    }
  });
  const schermen = stapSchermen(stepNo);
  if (!schermen.length) return zonderMaat.map(cat => renderCatGroup(cat, items, null, false)).join('');
  const sub = Math.min(currentSub, schermen.length - 1);
  const i = schermen[sub];
  const breedte = vlakken[i];

  let uit = `<div class="slot-head">${slotLabel(i, vlakken.length)}` +
            `<span class="slot-size">${breedte} cm</span>` +
            (schermen.length > 1 ? `<span class="slot-prog">${sub + 1}/${schermen.length}</span>` : ``) +
            `</div>`;
  uit += renderZelfdeKnop(stepNo, i, items);
  // Categorieen met de maat van dit ligvlak, en (in een stap per ligvlak)
  // de categorieen zonder maat, zoals het dekbedovertrek: per bed een keuze.
  uit += cats.filter(c => perVlakCat(c, stepNo) && vlakPast(c, i, vlakken))
             .map(cat => renderCatGroup(cat, items, i, plicht.includes(cat))).join('');
  // Wat voor het bed als geheel geldt (dak, ...) staat op het laatste scherm.
  if (sub === schermen.length - 1) {
    uit += zonderMaat.map(cat => renderCatGroup(cat, items, null, false)).join('');
  }
  return uit;
}

/* "Zelfde als onderbed": op het scherm van het bovenbed een knop die in een
   klik hetzelfde artikel kiest als bij het onderbed (ook als de breedte van
   het bovenbed anders is: dan wordt dezelfde productnaam in die maat gekozen). */
function zelfdeParen(stepNo, items){
  const vlakken = sleepSurfaces();
  if (vlakken.length !== 2) return [];
  const paren = [];
  Object.entries(selectedAcc).forEach(([key, bron]) => {
    if (slotOfKey(key) !== 1 || String(bron.step_no) !== String(stepNo) || !perVlakCat(bron.category, bron.step_no)) return;
    const kandidaten = items.filter(a => (categoryWidth(bron.category)
        ? categoryWidth(a.category) === vlakken[0]
        : a.category === bron.category) &&
      isAvailable(a) && !ontbrekendeVereiste(a) &&
      String(a.shopify && a.shopify.title) === String(bron.shopify && bron.shopify.title));
    const doel = kandidaten.find(a => a.sku === bron.sku) || kandidaten[0];
    if (doel) paren.push({ doel, aantal: Math.min(maxQtyFor(doel), qtyOf(key)) });
  });
  return paren;
}
function renderZelfdeKnop(stepNo, slot, items){
  if (slot !== 0) return "";
  if (heeftGastVlak()) return "";   // het logeerbed is geen "zelfde als"-geval
  const paren = zelfdeParen(stepNo, items);
  if (!paren.length) return "";
  const alGekozen = paren.every(p => selectedAcc[accKey(p.doel.sku, 0)] &&
    qtyOf(accKey(p.doel.sku, 0)) === p.aantal);
  const namen = paren.map(p => p.doel.shopify && p.doel.shopify.title || p.doel.sku).join(" + ");
  return `<button type="button" class="same-btn ${alGekozen ? 'selected' : ''}" onclick="kiesZelfde('${stepNo}')">` +
         `<span class="same-check">${alGekozen ? '✓' : '='}</span>` +
         `<span class="same-text">${escapeHtml(t("sameAsBottom", { v: namen }))}</span></button>`;
}
function kiesZelfde(stepNo){
  const paren = zelfdeParen(stepNo, stapItems(stepNo));
  if (!paren.length) return;
  paren.forEach(p => kiesIntern(p.doel, p.aantal, 0));
  paren.forEach(p => kiesVereistenBij(p.doel));
  handhaafVereisten();
  handhaafSubAccessoires();
  render();
}

// Van de gekozen item(s) in deze categorie: de eerste met minstens 1
// sub-accessoire (zie subAccessoriesVoor hierboven) -- normaal is dat er
// hoogstens 1, want de meeste van dit soort categorieën zijn zelf ook al
// "single"-selectie (zoals "Storage and guestbed").
function gekozenMetSubAcc(catItems, slot){
  return catItems.find(a => {
    const key = accKey(a.sku, slot);
    return !!selectedAcc[key] && subAccessoriesVoor(a.sku).length > 0;
  }) || null;
}
// Eén kaartje voor sub-accessoire "a" bij aantal "q". Net als bij een
// gewone accessoire (renderAccCards): bij max_qty 2 staan er dus twee
// kaartjes naast elkaar, 1x en 2x, allebei met de prijs voor dat aantal.
function renderSubAccCard(a, q){
  const max = maxQtyFor(a);
  const key = String(a.sku).trim().toUpperCase();
  const gekozen = isGekozenSubAcc(a.sku) &&
    (qtyOfSubAcc(key) === q || (q === max && qtyOfSubAcc(key) > max));
  const prijs = hasPrice(a) ? money(Number(a.shopify.price) * q, a.shopify.currency) : "";
  return `<div class="acc-card ${gekozen?'selected':''}" onclick="chooseSubAcc('${a.sku}',${q})">
    <div class="acc-check">✓</div>
    <div class="acc-thumb-wrap">
      ${fotoVan(a)
        ? `<img class="acc-thumb${heeftInfo(a)?' acc-thumb--zoom':''}" src="${fotoVan(a)}" alt="" loading="lazy"${heeftInfo(a)?` onclick="event.stopPropagation();openInfo('${a.sku}')"`:``} onerror="${fotoOnError(a,'acc-thumb acc-thumb--empty')}">`
        : `<div class="acc-thumb acc-thumb--empty"></div>`}
      ${max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``}
    </div>
    ${heeftInfo(a) ? `<button class="info-btn" title="${t("specsShow")}" onclick="event.stopPropagation();openInfo('${a.sku}')">i</button>` : ``}
    <div class="acc-name">${a.shopify?.title||a.sku}</div>
    ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
  </div>`;
}
// Eén kaartje per toegestaan aantal (1..max_qty) voor deze sub-accessoire.
function renderSubAccCards(a){
  const max = maxQtyFor(a);
  let uit = "";
  for (let q = 1; q <= max; q++) uit += renderSubAccCard(a, q);
  return uit;
}
// Sub-accessoires per categorie gegroepeerd tonen (10 sep 2026), zodat het
// duidelijk is als het om aparte keuzes gaat -- bv. dak + rugpaneel bij de
// "House Construction H128 cm"-optie. Is er maar 1 categorie (zoals bij de
// bestaande Beach House-optie: alleen "Roof"), dan verschijnt er geen extra
// kopje en ziet het er precies als voorheen uit.
function renderSubAccBlock(ouderAcc){
  const subs = subAccessoriesVoor(ouderAcc.sku).filter(a => isAvailable(a));
  if (!subs.length) return "";
  const cats = [...new Set(subs.map(a => a.category))];
  const groepen = cats.map(cat => {
    const catSubs = subs.filter(a => a.category === cat);
    const label = cats.length > 1
      ? `<div class="group-label subacc-cat-label">${categoryLabel(cat)}</div>` : ``;
    return `${label}<div class="acc-grid">${catSubs.map(a=>renderSubAccCards(a)).join('')}</div>`;
  }).join('');
  return `<div class="subacc-block">
    <div class="group-label subacc-label">${t("subAccessoryTitle", {v: ouderAcc.shopify?.title || ouderAcc.sku})}</div>
    ${groepen}
  </div>`;
}

function renderCatGroup(cat, items, slot, moetKiezen){
  const catItems = items.filter(i => i.category === cat);
  const required = moetKiezen || catItems.some(i => String(i.required).toLowerCase() === "yes");
  const ouderMetSub = gekozenMetSubAcc(catItems, slot);
  // Heeft minstens een artikel een tagline of kenmerken, dan staat de hele
  // groep in grote kaartjes (zie grootKaart/renderAccCards).
  const groot = catItems.some(grootKaart);
  const slotArg = (slot === null || slot === undefined) ? "null" : slot;
  const stapNo = catItems.length ? catItems[0].step_no : "";
  const geenKaart = moetKiezen
    ? renderGeenKaart(stapNo, cat, slot, slotArg, groot) : ``;
  return `<div class="group">
    <div class="group-label">${categoryLabel(cat)} ${required?`<span class="req-tag">${t("required")}</span>`:''}</div>
    <div class="acc-grid${groot ? ' acc-grid--groot' : ''}">
      ${catItems.map(a=>renderAccCards(a, slot, groot)).join('')}${geenKaart}
    </div>
    ${ouderMetSub ? renderSubAccBlock(ouderMetSub) : ``}
  </div>`;
}

// Het kaartje "Geen matras": een bewuste keuze om hier niets te nemen.
function renderGeenKaart(stapNo, cat, slot, slotArg, groot){
  const gekozen = isGeenGekozen(stapNo, cat, slot);
  const catArg = String(cat).replace(/\\/g, "\\\\").replace(/'/g, "\\'");
  return `<div class="acc-card acc-card--geen${groot ? ' acc-card--groot' : ''} ${gekozen ? 'selected' : ''}" onclick="chooseGeen('${stapNo}','${catArg}',${slotArg})">
      <div class="acc-check">✓</div>
      <div class="acc-thumb-wrap"><div class="acc-geen-icon">
        <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/></svg>
      </div></div>
      <div class="acc-body">
        <div class="acc-name">${escapeHtml(t("noMattress"))}</div>
      </div>
    </div>`;
}

// Kies bewust "Geen" in deze categorie en dit ligvlak; nogmaals klikken zet het uit.
function chooseGeen(stapNo, cat, slot){
  const sl = (slot === undefined) ? null : slot;
  const k = geenKey(stapNo, cat, sl);
  if (geenKeuze[k]) { delete geenKeuze[k]; render(); return; }
  Object.keys(selectedAcc).forEach(key => {
    const a = selectedAcc[key];
    if (a.category === cat && String(a.step_no) === String(stapNo) && slotOfKey(key) === sl) {
      delete selectedAcc[key]; delete accQty[key];
    }
  });
  geenKeuze[k] = true;
  handhaafVereisten();
  handhaafSubAccessoires();
  render();
}

/* --- Grote kaartjes met tagline en kenmerken (5 okt 2026) ---
   Gevuld via de metafields configurator.tagline (een regel) en
   configurator.facts (een kenmerk per regel, "Naam: waarde"). Zonder
   die velden blijft het kaartje zoals het was. */
function grootKaart(a){
  const s = (a && a.shopify) || {};
  return !!(String(s.tagline || "").trim() || String(s.facts || "").trim());
}
function feitenHtml(txt, max){
  const regels = String(txt || "").split(/\r?\n/).map(s => s.trim()).filter(Boolean).slice(0, max || 6);
  if (!regels.length) return "";
  return `<ul class="acc-facts">` + regels.map(r => {
    const i = r.indexOf(":");
    return (i > 0 && i < 40)
      ? `<li><span class="acc-fact-label">${escapeHtml(r.slice(0, i).trim())}</span><span class="acc-fact-val">${escapeHtml(r.slice(i + 1).trim())}</span></li>`
      : `<li><span class="acc-fact-val">${escapeHtml(r)}</span></li>`;
  }).join('') + `</ul>`;
}
function grootTekst(a){
  const s = (a && a.shopify) || {};
  const tag = String(s.tagline || "").trim();
  return `<div class="acc-name">${a.shopify?.title||a.sku}</div>` +
         (tag ? `<div class="acc-tagline">${escapeHtml(tag)}</div>` : ``) +
         feitenHtml(s.facts, 2);
}
// Prijs en "Meer info" staan onder de foto, zodat de tekst ernaast de
// volle breedte heeft en niet afgekapt hoeft te worden.
function grootVoet(a, prijs){
  return `<div class="acc-foot">${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}${heeftInfo(a) ? `<button type="button" class="acc-more" onclick="event.stopPropagation();openInfo('${a.sku}')">${t("readMore")}</button>` : ``}</div>`;
}
function grootThumb(a, extra, voet){
  return `<div class="acc-side"><div class="acc-thumb-wrap">
        ${fotoVan(a)
          ? `<img class="acc-thumb${heeftInfo(a)?' acc-thumb--zoom':''}" src="${fotoVan(a)}" alt="" loading="lazy"${heeftInfo(a)?` onclick="event.stopPropagation();openInfo('${a.sku}')"`:``} onerror="${fotoOnError(a,'acc-thumb acc-thumb--empty')}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}${extra || ""}
      </div>${voet || ""}</div>`;
}

/* Een accessoire krijgt EEN kaartje per toegestaan aantal. Bij max_qty 2
   staan er dus twee kaartjes naast elkaar: 1x en 2x, allebei met de prijs
   voor dat aantal. Zo kiest de klant het aantal in dezelfde klik. */
function renderAccCards(a, slot, groep){
  const max = maxQtyFor(a);
  const key = accKey(a.sku, slot);
  const slotArg = (slot === null || slot === undefined) ? "null" : slot;

  // Niet te koop, of een vereiste ontbreekt: één kaartje, gedimd, zonder klik.
  // De i-knop blijft werken, zodat de klant de specificaties nog wel kan lezen.
  const mist = isAvailable(a) ? ontbrekendeVereiste(a) : null;
  if (!isAvailable(a) || mist) {
    const prijs = hasPrice(a) ? money(a.shopify.price, a.shopify.currency) : "";
    if (groep || grootKaart(a)) {
      return `<div class="acc-card acc-card--groot acc-card--soldout">
      ${grootThumb(a, `<span class="acc-soldout">${mist ? t("requiresMissing", {v: naamVanSku(mist)}) : t("unavailable")}</span>`, grootVoet(a, prijs))}
      <div class="acc-body">${grootTekst(a)}
      </div>
    </div>`;
    }
    return `<div class="acc-card acc-card--soldout">
      <div class="acc-thumb-wrap">
        ${fotoVan(a)
          ? `<img class="acc-thumb${heeftInfo(a)?' acc-thumb--zoom':''}" src="${fotoVan(a)}" alt="" loading="lazy"${heeftInfo(a)?` onclick="event.stopPropagation();openInfo('${a.sku}')"`:``} onerror="${fotoOnError(a,'acc-thumb acc-thumb--empty')}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}
        <span class="acc-soldout">${mist ? t("requiresMissing", {v: naamVanSku(mist)}) : t("unavailable")}</span>
      </div>
      ${heeftInfo(a) ? `<button class="info-btn" title="${t("specsShow")}" onclick="event.stopPropagation();openInfo('${a.sku}')">i</button>` : ``}
      <div class="acc-name">${a.shopify?.title||a.sku}</div>
      ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
    </div>`;
  }

  let uit = "";
  for (let q = 1; q <= max; q++) {
    // Staat het aantal hoger dan er kaartjes zijn (bijgesteld in de
    // rechterkolom), dan blijft het hoogste kaartje aangevinkt.
    const gekozen = !!selectedAcc[key] &&
      (qtyOf(key) === q || (q === max && qtyOf(key) > max));
    const prijs = hasPrice(a) ? money(Number(a.shopify.price) * q, a.shopify.currency) : "";
    if (groep || grootKaart(a)) {
      uit += `<div class="acc-card acc-card--groot ${gekozen?'selected':''}" onclick="chooseAcc('${a.sku}',${q},${slotArg})">
      <div class="acc-check">✓</div>
      ${grootThumb(a, max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``, grootVoet(a, prijs))}
      <div class="acc-body">${grootTekst(a)}
      </div>
    </div>`;
      continue;
    }
    uit += `<div class="acc-card ${gekozen?'selected':''}" onclick="chooseAcc('${a.sku}',${q},${slotArg})">
      <div class="acc-check">✓</div>
      <div class="acc-thumb-wrap">
        ${fotoVan(a)
          ? `<img class="acc-thumb${heeftInfo(a)?' acc-thumb--zoom':''}" src="${fotoVan(a)}" alt="" loading="lazy"${heeftInfo(a)?` onclick="event.stopPropagation();openInfo('${a.sku}')"`:``} onerror="${fotoOnError(a,'acc-thumb acc-thumb--empty')}">`
          : `<div class="acc-thumb acc-thumb--empty"></div>`}
        ${max > 1 ? `<span class="acc-qty-badge">${q}×</span>` : ``}
      </div>
      ${heeftInfo(a) ? `<button class="info-btn" title="${t("specsShow")}" onclick="event.stopPropagation();openInfo('${a.sku}')">i</button>` : ``}
      <div class="acc-name">${a.shopify?.title||a.sku}</div>
      ${prijs ? `<div class="acc-price">+${prijs}</div>` : ``}
    </div>`;
  }
  return uit;
}

function renderConfigName(){
  if(!selectedBed) return `<div class="config-empty">${t("noBedSelected")}</div>`;
  const s = selectedBed.shopify||{};
  const chosen = chosenItems();
  // Ontbreekt bij één van de gekozen artikelen de prijs, dan tonen we
  // helemaal geen totaal -- een half totaal is misleidend.
  const complete = chosen.every(c => hasPrice(c.item));
  let total = 0;
  chosen.forEach(c => {
    if (!hasPrice(c.item)) return;
    total += Number(c.item.shopify.price) * c.qty;
  });
  return `<div class="config-name">${s.title||selectedBed.sku}</div>
    <div class="config-sku">SKU: ${selectedBed.sku}</div>
    ${complete ? `<div class="config-sku" style="margin-top:6px;color:var(--accent);">${t("total")}: ${money(total)}</div>` : ``}`;
}


/* --- Balk onderaan op mobiel ---
   Op smalle schermen staan de filters en het bed onder elkaar; deze balk
   houdt het gekozen bed en de prijs in beeld terwijl de klant door de
   filters scrolt, zodat hij niet steeds naar beneden hoeft om te zien wat
   hij al gekozen heeft. Op tablet/desktop blijft hij verborgen (zie CSS).
   Alleen deze functie en de bijbehorende CSS-klasse .mobile-bar regelen dit
   op te ruimen als er later een andere aanpak komt. */
function renderMobileBar(bedWeg, ontbreekt){
  if (!selectedBed) return "";
  const foto = fotoVan(selectedBed);
  const geblokkeerd = bedWeg || ontbreekt.length > 0;
  const isLaatsteStap = isLastScreen();

  // Zelfde optelsom als cartLabel(), hier apart zodat we prijs en knoptekst
  // los van elkaar kunnen tonen in plaats van uit één samengestelde zin.
  const chosen = chosenItems();
  const compleet = chosen.every(c => hasPrice(c.item));
  const totaal = chosen.reduce((som,c) => som + (hasPrice(c.item) ? Number(c.item.shopify.price)*c.qty : 0), 0);

  const knopTekst = isLaatsteStap
    ? (isDealerMode() ? t("createQuoteShort") : (compleet ? t("addToCartShort") : t("addToWishlist")))
    : t("next");

  return `<div class="mobile-bar">
    <button class="mobile-bar-preview" onclick="scrollNaarBeeld()" aria-label="${(selectedBed.shopify?.title||selectedBed.sku).replace(/"/g,'&quot;')}">
      ${foto ? `<img src="${foto}" alt="" loading="lazy">` : `<div class="mobile-bar-preview-empty"></div>`}
    </button>
    <div class="mobile-bar-info">
      <div class="mobile-bar-name">${selectedBed.shopify?.title || selectedBed.sku}</div>
      ${compleet ? `<div class="mobile-bar-total">${money(totaal)}</div>` : ``}
    </div>
    <button class="cta mobile-bar-cta" onclick="onCartClick()" ${geblokkeerd?'disabled':''}>${knopTekst}</button>
  </div>`;
}

// Scrolt het rechterblok (bed + prijs) in beeld; op mobiel staat dat onder
// de filters. Gebruikt de bestaande .canvas-container, geen nieuwe structuur.
function scrollNaarBeeld(){
  const el = document.querySelector('.bed-configurator-root .canvas');
  if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function cartLabel(){
  if(!selectedBed) return t("chooseBedFirst");
  const chosen = chosenItems();
  const complete = chosen.every(c => hasPrice(c.item));
  let total = 0;
  chosen.forEach(c => {
    if (!hasPrice(c.item)) return;
    total += Number(c.item.shopify.price) * c.qty;
  });
  const isLast = isLastScreen();

  if (!complete) {
    // Geen prijzen in deze markt: het is een wishlist (of, in dealer-modus,
    // gewoon een offerte zonder bedragen) in plaats van een winkelmand.
    if (!isLast) return t("continuePlain");
    return isDealerMode() ? t("createQuoteShort") : t("addToWishlist");
  }
  const price = money(total);
  if (!isLast) return t("continueBtn", {price});
  return isDealerMode() ? t("createQuote", {price}) : t("addToCart", {price});
}

/* =====================================================================
   INTERACTIONS
   ===================================================================== */
// Scrolt terug naar de bovenkant van de configurator zelf bij een stapwissel.
// Zonder dit blijft de pagina op de hoogte staan van de vorige stap, en kan
// de klant boven aan de nieuwe stap -- met de titel en de eerste opties --
// buiten beeld vallen als die stap korter is dan de vorige.
/* ---------------- Meten: gebruik en conversie ----------------
   GA4-events voor het gebruik van de configurator. Stuurt niets als er geen
   Analytics op de pagina staat (gtag of dataLayer) -- geen fout, gewoon een
   no-op. Werkt met zowel het klassieke gtag-script als een kale dataLayer. */
function meetGebeurtenis(naam, extra){
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", naam, extra || {});
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: naam, ...(extra || {}) });
    }
  } catch (e) {
    console.warn("Bed configurator: meting kon niet verstuurd worden.", e);
  }
}

// "webshop" voor de gewone configurator, "dealer" op een touchscreen-pagina
// met dealer-modus aan. Zo zijn beide in de rapportages te onderscheiden.
function meetKanaal(){
  return isDealerMode() ? "dealer" : "webshop";
}

let gebruikGemeld = false;   // één keer per bezoek aan de configurator

function scrollNaarTop(){
  if (typeof document === "undefined" || typeof document.querySelector !== "function") return;
  const el = document.querySelector('.bed-configurator-root');
  if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function goToStep(n){
  if(n===1||selectedBed){
    const nieuw = Math.min(n, activeSteps().length);
    if (nieuw !== currentStep) currentSub = 0;
    currentStep = nieuw; render(); scrollNaarTop();
  }
}
function nextStep(){
  if (blockingChoices().length) return;
  const st = activeSteps()[currentStep - 1];
  // Eerst de volgende ligvlak-schermen binnen deze stap, dan de volgende stap.
  if (st && currentSub < aantalSchermen(st.step_no) - 1) { currentSub++; render(); scrollNaarTop(); return; }
  if(currentStep<activeSteps().length){ currentStep++; currentSub = 0; render(); scrollNaarTop(); }
}
function prevStep(){
  if (currentSub > 0) { currentSub--; render(); scrollNaarTop(); return; }
  if(currentStep>1){
    currentStep--;
    // Terug in een stap met meerdere schermen: beginnen bij het laatste scherm.
    const st = activeSteps()[currentStep - 1];
    currentSub = st ? aantalSchermen(st.step_no) - 1 : 0;
    render(); scrollNaarTop();
  }
}

function toggleFilter(key,val){
  const zichtbaar = visibleFilters();
  const i = zichtbaar.findIndex(f => f.filter_key === key);
  if (i === -1) return;

  const wasActive = String(filters[key]||"").toLowerCase() === String(val).toLowerCase();

  // Alles ONDER dit filter hoort bij de oude route en vervalt.
  zichtbaar.slice(i+1).forEach(f => { filters[f.filter_key] = ""; });
  if (slatsAsStep()) filters[SLAT_FILTER_KEY] = "";

  // Opnieuw op dezelfde keuze klikken zet hem uit; hij wordt alleen
  // teruggezet als het toch de enige mogelijkheid is.
  filters[key] = wasActive ? "" : String(val);

  autoAdvance();

  const matches = DATA.beds.filter(bedMatchesFilters);
  // Houd het huidige bed als het nog past. Maar heeft de klant net een
  // optioneel filter uitgezet, dan hoort hij het kale bed terug te krijgen.
  selectedBed = (matches.includes(selectedBed) && isPlainForEmptyOptionals(selectedBed))
    ? selectedBed
    : pickBed(matches);
  // drop incompatibele accessoires
  actieveFoto = 0;   // nieuw bed: altijd weer het hoofdbeeld tonen
  // bevestigdeFotos blijft per SKU bestaan, dus bij teruggaan naar een eerder
  // bekeken bed hoeft er niet opnieuw getest te worden
  if(selectedBed){
    // Keuzes die niet meer kunnen vervallen: niet compatibel met het nieuwe
    // bed, of horend bij een ligvlak dat dit bed niet (meer) heeft.
    const vlakken = sleepSurfaces();
    Object.keys(selectedAcc).forEach(key=>{
      const a = selectedAcc[key];
      const slot = slotOfKey(key);
      const hoortBijVlak = vlakken.length > 1 && perVlakCat(a.category, a.step_no);
      const weg = !accCompatibleWithBed(a, selectedBed.sku) || (hoortBijVlak
        ? (slot === null || slot >= vlakken.length || !vlakPast(a.category, slot, vlakken))
        : slot !== null);
      if (weg) { delete selectedAcc[key]; delete accQty[key]; }
    });
    pruneGeenKeuze();
    handhaafVereisten();
  } else { selectedAcc = {}; accQty = {}; geenKeuze = {}; }
  handhaafSubAccessoires();   // sub-accessoire dat niet bij het nieuwe bed past (bv. afdekplaat van een andere breedte) vervalt
  render();
}

// Bewuste "geen"-keuzes die niet meer passen bij het (nieuwe) bed vervallen.
function pruneGeenKeuze(){
  const vlakken = sleepSurfaces();
  Object.keys(geenKeuze).forEach(k => {
    const [stapNo, cat, slotTxt] = k.split("|");
    const slot = slotTxt === "" ? null : Number(slotTxt);
    const bestaat = !!selectedBed && stapItems(stapNo).some(a => a.category === cat);
    const hoortBijVlak = vlakken.length > 1 && !!categoryWidth(cat);
    const klopt = hoortBijVlak
      ? (slot !== null && slot < vlakken.length && categoryWidth(cat) === vlakken[slot])
      : slot === null;
    if (!bestaat || !klopt) delete geenKeuze[k];
  });
}

// Aantal bijstellen vanuit de rechterkolom. Werkt op de keuze-sleutel, dus
// boven- en onderbed hebben elk hun eigen aantal.
function changeQty(key, delta){
  if (!selectedAcc[key]) return;
  accQty[key] = Math.min(MAX_QTY, Math.max(1, qtyOf(key) + delta));
  render();
}

function removeAcc(key){
  delete selectedAcc[key];
  delete accQty[key];
  handhaafVereisten();   // wat hiervan afhing gaat mee
  handhaafSubAccessoires();   // en een sub-accessoire waarvan de ouder weg is
  render();
}

// 4. Alles wissen en opnieuw beginnen -- werkt in elke stap.
function startOver(){
  if (!confirm(t("startOverAsk"))) return;
  selectedAcc = {};
  accQty = {};
  geenKeuze = {};
  selectedSubAcc = {};
  subAccQty = {};
  currentStep = 1;
  currentSub = 0;
  initFilters();
  render();
}

// Klik op een kaartje: kies dit artikel in dit aantal. Nogmaals op hetzelfde
// kaartje klikken zet de keuze weer uit; op het buurkaartje klikken wisselt
// alleen het aantal.
// Het kiezen zelf, zonder opnieuw te tekenen. Wordt ook gebruikt om vereisten
// er automatisch bij te zetten.
function kiesIntern(acc, n, slot){
  const key = accKey(acc.sku, slot);
  // Een gekozen artikel maakt een eerdere bewuste "geen" ongedaan.
  delete geenKeuze[geenKey(acc.step_no, acc.category, slot)];
  if (String(acc.selection).toLowerCase() === "single") {
    // Andere keuzes in dezelfde categorie + stap vervallen, maar alleen
    // binnen HETZELFDE ligvlak. Boven- en onderbed staan los van elkaar.
    Object.keys(selectedAcc).forEach(other => {
      if (other === key) return;
      const o = selectedAcc[other];
      if (o.category === acc.category && String(o.step_no) === String(acc.step_no) &&
          slotOfKey(other) === slotOfKey(key)) {
        delete selectedAcc[other]; delete accQty[other];
      }
    });
  }
  selectedAcc[key] = acc;
  accQty[key] = n;
}

function chooseAcc(sku, aantal, slot){
  const acc = DATA.accessories.find(a=>a.sku===sku);
  if (!acc || !isAvailable(acc)) return;
  // Ontbreekt een vereiste bij dit bed, dan is het artikel niet te kiezen.
  if (ontbrekendeVereiste(acc)) return;

  const n = Math.min(maxQtyFor(acc), Math.max(1, Number(aantal) || 1));
  const key = accKey(sku, slot);

  if (selectedAcc[key] && qtyOf(key) === n) {
    delete selectedAcc[key];
    delete accQty[key];
    handhaafVereisten();
    handhaafSubAccessoires();
    render();
    return;
  }

  kiesIntern(acc, n, slot);
  kiesVereistenBij(acc);      // het dak komt er vanzelf bij
  handhaafVereisten();        // en wat zijn vereiste kwijt is, gaat eruit
  handhaafSubAccessoires();   // en een sub-accessoire waarvan de ouder is vervangen
  render();
}

function onCartClick(){
  if(!selectedBed || !isAvailable(selectedBed)) return;
  if(blockingChoices().length) return;
  if(!isLastScreen()){ nextStep(); return; }
  if (isDealerMode()) { openQuoteModal(); return; }
  addToCart();
}

/* =====================================================================
   ADD TO CART (Shopify Cart AJAX API)
   In demo-modus (variant_id begint met 'demo-') tonen we alleen een overzicht.
   ===================================================================== */
// Zijn er prijzen in deze markt? Zo niet, dan gedraagt de lijst zich als
// wishlist (zelfde winkelmand, andere bewoording).
function isWishlist(){
  if (!selectedBed) return false;
  return !chosenItems().every(c => hasPrice(c.item));
}

function numericVariantId(gid){
  if(!gid) return null;
  const m = String(gid).match(/(\d+)$/);
  return m ? Number(m[1]) : null;
}

async function addToCart(){
  const chosen = chosenItems();

  // Regels opbouwen; alleen artikelen met een geldig variant-ID. Twee keer
  // hetzelfde matras (boven en onder) wordt één regel met aantal 2.
  const perVariant = new Map();
  const zonderVariant = [];
  for (const { item, qty, isBed } of chosen) {
    const ref = item.variant_id || item.shopify?.defaultVariantId;
    const id = numericVariantId(ref);
    if (!id) { zonderVariant.push(item.sku); continue; }
    if (perVariant.has(id)) { perVariant.get(id).quantity += qty; continue; }
    perVariant.set(id, {
      id,
      quantity: qty,
      // Dit label staat op de order/pakbon in de administratie, dus bewust
      // NIET via t() (die volgt de taal van de klant) maar altijd in het
      // Engels als "Configurator" -- op verzoek 15 sep 2026, zelfde principe
      // als het "Rebuild"-label van de ombouw-tool (assets/rebuild-
      // configurator.js), voor één vaste taal op alle orders ongeacht de
      // markt waarop besteld is.
      properties: isBed
        ? { "Configurator": `${item.shopify?.title || item.sku} (${item.sku})`,
            "_bed_configurator": "yes" }   // onzichtbaar kenmerk; Flow zet hier een tag op de order mee
        : { [t("propPartOf")]: selectedBed.sku },
    });
  }
  const items = [...perVariant.values()];

  if (zonderVariant.length) {
    console.warn("Geen variant-ID voor:", zonderVariant.join(", "));
  }
  if (!items.length) {
    alert(isWishlist() ? t("wishlistError") : t("cartError"));
    return;
  }

  // Demo-modus: niets echt toevoegen. Draait de configurator op data uit de
  // pagina, dan is er geen backend-URL en moet hij juist WEL toevoegen.
  if (String(items[0].id).startsWith("demo") || !dataUitPagina()) {
    alert("DEMO: " + items.length + " regels zouden nu toegevoegd worden.");
    return;
  }

  try{
    const r = await fetch(winkelPad("/cart/add.js"), {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items })
    });

    if (r.ok) {
      const totaal = chosen.reduce((som,c) => som + (hasPrice(c.item) ? Number(c.item.shopify.price)*c.qty : 0), 0);
      meetGebeurtenis(isWishlist() ? "bed_configurator_wishlist_add" : "bed_configurator_add_to_cart", {
        value: Math.round(totaal * 100) / 100,
        currency: CURRENCY || undefined,
        bed_sku: selectedBed ? selectedBed.sku : undefined,
        items: items.length,
        channel: meetKanaal(),
      });
      window.location.href = winkelPad("/cart");
      return;
    }

    // Shopify vertelt zelf wat er misging; die reden tonen we.
    let reden = "";
    try {
      const err = await r.json();
      reden = err.description || err.message || "";
      console.error("Cart-fout van Shopify:", err, "| verstuurd:", items);
    } catch {
      reden = await r.text().catch(()=> "");
      console.error("Cart-fout (geen JSON):", reden, "| verstuurd:", items);
    }

    const basis = isWishlist() ? t("wishlistError") : t("cartError");

    // Shopify zegt niet WELK artikel het probleem is. Wij weten wel welke
    // producten niet in de webshop staan -- die noemen we bij naam.
    const verdachten = chosen
      .map(c => c.item)
      .filter((x, i, arr) => arr.indexOf(x) === i)
      .filter(x => x.shopify && x.shopify.publishedOnline === false)
      .map(x => `• ${x.shopify?.title || x.sku} (${x.sku}) — ${t("cartNotForSale")}`);

    let tekst = basis;
    if (reden) tekst += `\n\n${reden}`;
    if (verdachten.length) tekst += `\n\n${t("cartBlocked")}\n${verdachten.join("\n")}`;

    console.error("Niet-gepubliceerde artikelen in de selectie:",
      chosen.map(c=>c.item).filter(x=>x.shopify?.publishedOnline===false).map(x=>x.sku));
    alert(tekst);
  }catch(e){
    console.error("Netwerkfout bij toevoegen aan winkelmand:", e);
    alert(t("networkError", {msg: e.message}));
  }
}

/* =====================================================================
   DEALER-MODUS — OFFERTE MAKEN (PDF, geen backend)
   Staat de sectie-instelling "Dealer-modus" aan, dan wordt in de laatste
   stap geen winkelmand-item toegevoegd, maar een PDF-offerte gemaakt en,
   waar de browser dat toelaat, meteen klaargezet om te versturen. Draait
   volledig in de browser: geen Netlify, geen andere dienst, geen wachtwoord
   of sleutel nodig. Zie claude/dealers-offerte-plan.md in het project voor
   de achtergrond van deze keuze.
   ===================================================================== */
function isDealerMode(){
  return !!(window.BED_CONFIGURATOR_SETTINGS && window.BED_CONFIGURATOR_SETTINGS.dealerMode);
}

function isValidEmail(v){
  // Simpele, bewust ruime controle -- geen poging om elk geldig adres tot
  // in de puntjes te valideren, alleen de meest voorkomende tikfouten vangen.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
}

function openQuoteModal(){
  if (!chosenItems().length) { alert(t("quoteNoItems")); return; }

  const overlay = document.createElement("div");
  overlay.className = "guide-overlay";
  overlay.innerHTML = `
    <div class="guide-box quote-box" role="dialog" aria-modal="true" aria-label="${t("quoteModalTitle")}">
      <button class="guide-close" aria-label="${t("quoteCancelBtn")}">&times;</button>
      <div class="quote-content">
        <h3 class="quote-title">${t("quoteModalTitle")}</h3>
        <p class="quote-intro">${t("quoteIntro")}</p>
        <label class="quote-label" for="quoteDealerInput">${t("quoteDealerLabel")} *</label>
        <input type="text" id="quoteDealerInput" class="quote-input" placeholder="${t("quoteDealerPlaceholder")}" autocomplete="off">
        <label class="quote-label" for="quoteDealerEmailInput">${t("quoteDealerEmailLabel")} *</label>
        <input type="email" id="quoteDealerEmailInput" class="quote-input" placeholder="${t("quoteDealerEmailPlaceholder")}" autocomplete="off">
        <label class="quote-label" for="quoteEmailInput">${t("quoteEmailLabel")} *</label>
        <input type="email" id="quoteEmailInput" class="quote-input" placeholder="${t("quoteEmailPlaceholder")}" autocomplete="email">
        <label class="quote-label" for="quoteNameInput">${t("quoteNameLabel")} *</label>
        <input type="text" id="quoteNameInput" class="quote-input" placeholder="${t("quoteNamePlaceholder")}" autocomplete="name">
        <div class="quote-error" id="quoteErrorBox" style="display:none;"></div>
        <div class="quote-actions">
          <button type="button" class="cta cta-ghost" id="quoteCancelBtn">${t("quoteCancelBtn")}</button>
          <button type="button" class="cta cta-secondary" id="quoteDownloadBtn">${t("quoteDownloadBtn")}</button>
          <button type="button" class="cta" id="quoteEmailActionBtn">${t("quoteEmailBtn")}</button>
        </div>
      </div>
    </div>`;
  document.body.appendChild(overlay);

  const sluit = () => { overlay.remove(); document.removeEventListener("keydown", esc); };
  function esc(e){ if (e.key === "Escape") sluit(); }
  overlay.addEventListener("click", e => { if (e.target === overlay) sluit(); });
  overlay.querySelector(".guide-close").addEventListener("click", sluit);
  overlay.querySelector("#quoteCancelBtn").addEventListener("click", sluit);
  document.addEventListener("keydown", esc);

  const dealerInput = overlay.querySelector("#quoteDealerInput");
  const dealerEmailInput = overlay.querySelector("#quoteDealerEmailInput");
  const emailInput = overlay.querySelector("#quoteEmailInput");
  const nameInput = overlay.querySelector("#quoteNameInput");
  const errorBox = overlay.querySelector("#quoteErrorBox");
  const downloadBtn = overlay.querySelector("#quoteDownloadBtn");
  const emailBtn = overlay.querySelector("#quoteEmailActionBtn");

  const toonFout = (msg) => {
    errorBox.textContent = msg;
    errorBox.style.display = "block";
  };

  // ALLE vier de velden (dealernaam, dealer-e-mailadres, e-mailadres van de
  // klant, naam van de klant) zijn verplicht, bij BEIDE knoppen (PDF
  // downloaden en per e-mail versturen) -- zonder volledig, geldig ingevulde
  // velden wordt er geen PDF gebouwd. Controleert in dezelfde volgorde als
  // op het scherm, toont de foutmelding van het eerste veld dat niet klopt
  // en zet de focus daarop. Spaties alleen telt als leeg. Geeft null terug
  // als er iets niet klopt, anders de getrimde waarden.
  function valideerAlles(){
    const dealerNaam = dealerInput.value.trim();
    if (!dealerNaam) {
      toonFout(t("quoteDealerRequired"));
      dealerInput.focus();
      return null;
    }
    const dealerEmail = dealerEmailInput.value.trim();
    if (!isValidEmail(dealerEmail)) {
      toonFout(t("quoteInvalidDealerEmail"));
      dealerEmailInput.focus();
      return null;
    }
    const email = emailInput.value.trim();
    if (!isValidEmail(email)) {
      toonFout(t("quoteInvalidEmail"));
      emailInput.focus();
      return null;
    }
    const naam = nameInput.value.trim();
    if (!naam) {
      toonFout(t("quoteNameRequired"));
      nameInput.focus();
      return null;
    }
    return { dealerNaam, dealerEmail, email, naam };
  }

  // Schakelt tijdens het bouwen van de PDF allebei de knoppen uit (zodat er
  // niet twee offertes tegelijk gestart kunnen worden) en toont "Bezig…" op
  // de knop die is ingedrukt.
  function zetBezig(actieveBtn, bezig){
    downloadBtn.disabled = bezig;
    emailBtn.disabled = bezig;
    if (bezig) {
      actieveBtn.dataset.origText = actieveBtn.textContent;
      actieveBtn.textContent = t("quoteGenerating");
    } else if (actieveBtn.dataset.origText) {
      actieveBtn.textContent = actieveBtn.dataset.origText;
    }
  }

  downloadBtn.addEventListener("click", async () => {
    const gegevens = valideerAlles();
    if (!gegevens) return;
    errorBox.style.display = "none";
    zetBezig(downloadBtn, true);
    try {
      await downloadOfferte(gegevens);
      sluit();
    } catch (e) {
      console.error("PDF downloaden mislukt:", e);
      toonFout(t("quoteError"));
      zetBezig(downloadBtn, false);
    }
  });

  // Per e-mail versturen: de dealer krijgt via cc automatisch ook een kopie
  // (zie de e-mail-functie), zodat de dealer altijd een bewijs van de
  // verstuurde offerte behoudt.
  emailBtn.addEventListener("click", async () => {
    const gegevens = valideerAlles();
    if (!gegevens) return;
    errorBox.style.display = "none";
    zetBezig(emailBtn, true);
    try {
      await verstuurOfferteViaEmail(gegevens);
      sluit();
    } catch (e) {
      console.error("Offerte versturen mislukt:", e);
      toonFout(t("quoteError"));
      zetBezig(emailBtn, false);
    }
  });

  if (typeof dealerInput.focus === "function") {
    setTimeout(() => dealerInput.focus(), 30);
  }
}

// Bouwt de offerteregels (bed + gekozen accessoires) uit de huidige keuzes.
// Puur synchroon, geen PDF- of netwerkwerk hier -- dat gebeurt in
// genereerOffertePdf(). Gooit een fout bij een lege selectie.
function bouwOfferteRegels(){
  const chosen = chosenItems();
  if (!chosen.length) throw new Error("Geen artikelen gekozen");

  const metPrijzen = chosen.every(c => hasPrice(c.item));
  const regels = chosen.map(c => {
    const eenheidsprijs = hasPrice(c.item) ? Number(c.item.shopify.price) : null;
    return {
      titel: c.item.shopify?.title || c.item.sku,
      sku: c.item.sku,
      aantal: c.qty,
      prijsTekst: eenheidsprijs != null ? money(eenheidsprijs) : "",
      totaalTekst: eenheidsprijs != null ? money(eenheidsprijs * c.qty) : "",
      // Zelfde foto als in de configurator zelf (kleine/thumbnail-versie);
      // ontbreekt die, dan blijft dit "" en slaat de PDF de afbeelding
      // gewoon over voor deze regel (zie laadAfbeeldingAlsDataUrl).
      fotoUrl: fotoVan(c.item) || "",
      // Terugval-URL, exact dezelfde als het scherm zelf gebruikt via het
      // onerror-attribuut (fotoOnError/fotoTerugval): de gewone product-/
      // variantfoto, voor als de speciale "configurator_SKU"-foto niet
      // (meer) bestaat in Shopify's bestanden. Zie maakOffertePdfV2.
      fotoUrlTerugval: fotoTerugval(c.item) || "",
    };
  });
  const totaal = chosen.reduce((som, c) => som + (hasPrice(c.item) ? Number(c.item.shopify.price) * c.qty : 0), 0);

  return {
    chosen, regels, metPrijzen,
    totaalTekst: metPrijzen ? money(totaal) : "",
    totaalRuw: totaal,
  };
}

// Supabase Edge Function "send-offerte" (2 okt 2026) -- verstuurt de offerte
// echt per e-mail vanaf onze eigen server (via Resend), met een kopie in de
// tabel `offertes`. Opgezet omdat een touchscreen zonder eigen
// mailprogramma voorheen geen enkele "Per e-mail versturen"-route had die
// echt iets verstuurde (zie dealers-offerte-plan.md). De publishable key
// hieronder is met opzet net zo "openbaar" als de rest van deze
// frontend-code (vergelijkbaar met een normale website-API-sleutel) --
// zonder deze sleutel wijst de server elke aanvraag af, en de server mag
// zelf nooit iets anders dan deze ene tabel beschrijven en e-mails sturen.
const SUPABASE_OFFERTE_FUNCTIE_URL = "https://dqodtpnuboyjkgezjkxc.supabase.co/functions/v1/send-offerte";
const SUPABASE_OFFERTE_PUBLISHABLE_KEY = "sb_publishable_UuhVnetaN1DgUEA3daWWYQ_SXms6Rms";

// Bouwt de regels, genereert de PDF (met logo + productfoto's) en meet de
// gebeurtenis. Gedeeld door zowel "Downloaden" als "Per e-mail versturen" --
// die verschillen alleen in wat ze met het resultaat doen. Gooit een fout
// bij lege selectie of als de PDF niet gebouwd kan worden; de aanroeper
// (openQuoteModal) vangt die op en toont een nette melding.
async function genereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie }){
  if (!window.OffertePdf || typeof window.OffertePdf.maakOffertePdfV2 !== "function") {
    // offerte-pdf.js (de gedeelde PDF-motor) is niet geladen -- meestal
    // omdat dat bestand nog niet als Asset in Shopify Admin staat, of omdat
    // de <script>-tag ervoor per ongeluk is verwijderd uit
    // configurator-sectie.liquid. Duidelijke melding i.p.v. een cryptische
    // "cannot read properties of undefined".
    throw new Error("offerte-pdf.js is niet geladen (ontbreekt als Asset in Shopify, of de <script>-tag ervoor is weg).");
  }
  const { chosen, regels, metPrijzen, totaalTekst, totaalRuw } = bouwOfferteRegels();
  const datumTekst = new Date().toLocaleDateString(pdfLocale());
  const logoUrl = (window.BED_CONFIGURATOR_SETTINGS && window.BED_CONFIGURATOR_SETTINGS.dealerLogoUrl) || "";
  const bedTitel = (selectedBed && (selectedBed.shopify?.title || selectedBed.sku)) || "";

  const pdfBytes = await window.OffertePdf.maakOffertePdfV2({
    regels,
    metPrijzen,
    totaalTekst,
    klantNaam: naam,
    klantEmail: email,
    dealerNaam,
    dealerEmail,
    bedTitel,
    datumTekst,
    logoUrl,
    vertaal: t,
  });

  meetGebeurtenis("bed_configurator_quote_created", {
    value: metPrijzen ? Math.round(totaalRuw * 100) / 100 : undefined,
    currency: metPrijzen ? (CURRENCY || undefined) : undefined,
    bed_sku: selectedBed ? selectedBed.sku : undefined,
    items: chosen.length,
    channel: meetKanaal(),
    action: actie,
    dealer: dealerNaam || undefined,
  });

  const bestandsnaam = `offerte-${(selectedBed && selectedBed.sku) || "bed"}-${Date.now()}.pdf`;
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  return { blob, bestandsnaam, pdfBytes, regels, metPrijzen, totaalTekst, bedTitel };
}

// Knop "PDF downloaden": maakt de PDF en zet die meteen als download klaar.
// Alle velden (dealer + klant, naam en e-mailadres) zijn al gevalideerd door
// openQuoteModal voordat dit aangeroepen wordt (verplicht sinds 5 okt 2026).
async function downloadOfferte({ email, naam, dealerNaam, dealerEmail }){
  const { blob, bestandsnaam } = await genereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie: "download" });
  downloadOffertePdf(blob, bestandsnaam);
}

// Probeert de offerte via onze eigen Supabase Edge Function (zie
// SUPABASE_OFFERTE_FUNCTIE_URL hierboven) écht per e-mail te laten
// versturen. Geeft `true` terug bij een bevestigd succes, en in ALLE
// andere gevallen (geen internet, server niet bereikbaar, functie geeft
// een fout, ontbrekende hulpfunctie) gewoon `false` -- nooit een fout die
// verder omhoog gegooid wordt, zodat de aanroeper altijd gewoon op de
// bestaande Web Share/mailto-terugval kan overschakelen.
async function verstuurOfferteViaServer({ email, dealerEmail, klantNaam, dealerNaam, bedTitel, totaalTekst, regels, pdfBytes, bestandsnaam }){
  if (typeof fetch !== "function") return false;
  if (!window.OffertePdf || typeof window.OffertePdf.pdfArrayBufferNaarBase64 !== "function") return false;

  const pdfBase64 = window.OffertePdf.pdfArrayBufferNaarBase64(pdfBytes);
  if (!pdfBase64) return false;

  const controller = (typeof AbortController === "function") ? new AbortController() : null;
  const timeoutId = controller ? setTimeout(() => controller.abort(), 20000) : null;
  try {
    const res = await fetch(SUPABASE_OFFERTE_FUNCTIE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "apikey": SUPABASE_OFFERTE_PUBLISHABLE_KEY },
      body: JSON.stringify({
        email,
        dealerEmail,
        klantNaam,
        dealerNaam,
        storeId: dealerNaam,
        taal: LOCALE,
        bedTitel,
        totaalTekst,
        regels,
        pdfBase64,
        bestandsnaam,
      }),
      signal: controller ? controller.signal : undefined,
    });
    if (!res.ok) {
      console.warn("[offerte] server gaf een foutstatus, val terug op delen/mailto:", res.status);
      return false;
    }
    const data = await res.json().catch(() => null);
    if (!data || data.ok !== true) {
      console.warn("[offerte] server meldt dat versturen niet gelukt is, val terug op delen/mailto:", data && data.error);
      return false;
    }
    return true;
  } catch (e) {
    // Geen internet, CORS-probleem, functie niet bereikbaar, timeout, ...
    // -- in alle gevallen gewoon terugvallen, nooit de offerte laten
    // mislukken op een server-probleem.
    console.warn("[offerte] server niet bereikbaar, val terug op delen/mailto:", e && e.message);
    return false;
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}

// Knop "Per e-mail versturen": probeert eerst de offerte écht te laten
// versturen via onze eigen server (verstuurOfferteViaServer hierboven,
// sinds 2 okt 2026). Lukt dat, dan is de klant al gemaild (met de dealer
// in cc) en is er verder niets meer te doen. Lukt dat niet -- bijvoorbeeld
// omdat het touchscreen geen internet heeft op dat moment, of de server
// een keer niet reageert -- dan valt dit terug op de oorspronkelijke
// manier: eerst de Web Share API proberen (bv. het deelvenster met "Mail"
// als optie), en anders downloaden + een mailto-concept met het
// dealer-adres als cc (zie openOfferteMailConcept) -- een mailto-link kan
// nooit automatisch een bijlage meesturen, dus dat blijft de beste
// terugval-terugval.
async function verstuurOfferteViaEmail({ email, naam, dealerNaam, dealerEmail }){
  const { blob, bestandsnaam, pdfBytes, regels, metPrijzen, totaalTekst, bedTitel } =
    await genereerOffertePdf({ email, naam, dealerNaam, dealerEmail, actie: "email" });

  const serverGelukt = await verstuurOfferteViaServer({
    email, dealerEmail, klantNaam: naam, dealerNaam, bedTitel, totaalTekst, regels, pdfBytes, bestandsnaam,
  });
  if (serverGelukt) return;

  let gedeeld = false;
  if (typeof navigator !== "undefined" && navigator.share && navigator.canShare && typeof File === "function") {
    try {
      const file = new File([blob], bestandsnaam, { type: "application/pdf" });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: t("quoteModalTitle"), text: t("quoteShareText", { email }) });
        gedeeld = true;
      }
    } catch (e) {
      // Geannuleerd door de gebruiker: geen fout, gewoon niets doen.
      // Iets anders misgegaan: gewoon terugvallen op downloaden.
      if (e && e.name === "AbortError") gedeeld = true;
    }
  }

  if (!gedeeld) {
    downloadOffertePdf(blob, bestandsnaam);
    openOfferteMailConcept(email, dealerEmail, bestandsnaam);
  }
}

// Taalcode voor Intl.DateTimeFormat/toLocaleDateString; "en" wordt "en-GB"
// zodat de datum als dag-maand-jaar staat, consistent met de rest van Europa.
function pdfLocale(){
  return LOCALE === "en" ? "en-GB" : LOCALE;
}

function downloadOffertePdf(blob, bestandsnaam){
  if (typeof URL === "undefined" || typeof document === "undefined") return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = bestandsnaam;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

// dealerEmail komt als "cc" in de mailto-link terecht, zodat de dealer bij
// het versturen automatisch ook zelf een kopie krijgt -- geen apart bericht
// nodig. Werkt alleen als er straks daadwerkelijk een mailprogramma opent
// (zie de kanttekening bij verstuurOfferteViaEmail hierboven).
function openOfferteMailConcept(email, dealerEmail, bestandsnaam){
  if (typeof window === "undefined") return;
  const onderwerp = encodeURIComponent(t("quoteMailSubject"));
  const body = encodeURIComponent(t("quoteMailBody", { file: bestandsnaam }));
  const cc = dealerEmail ? `&cc=${encodeURIComponent(dealerEmail)}` : "";
  window.location.href = `mailto:${encodeURIComponent(email)}?subject=${onderwerp}${cc}&body=${body}`;
}

/* =====================================================================
   OFFERTE-PDF -- de opmaakmotor zelf staat sinds 7 sep 2026 in het GEDEELDE
   bestand offerte-pdf.js (window.OffertePdf.maakOffertePdfV2), zodat de
   REBUILD-tool (rebuild-configurator.js) dezelfde, grondig geteste
   PDF-motor kan hergebruiken in plaats van deze ~350 regels te moeten
   kopiëren. offerte-pdf.js moet in configurator-sectie.liquid NA
   jspdf.umd.min.js / pdf-lettertype.js en VOOR dit bestand geladen worden.
   Zie genereerOffertePdf() hierboven voor de aanroep, en offerte-pdf.js
   voor de volledige uitleg (lay-out, lettertype-inbakken, foto-terugval).
   ===================================================================== */

loadData();